{
  "about.blocks": "Gweinyddion wedi'u cymedroli",
  "about.contact": "Cysylltiad:",
  "about.default_locale": "Rhagosodedig",
  "about.disclaimer": "Mae Mastodon yn feddalwedd cod agored rhydd ac o dan hawlfraint Mastodon gGmbH.",
  "about.domain_blocks.no_reason_available": "Dyw'r rheswm ddim ar gael",
  "about.domain_blocks.preamble": "Fel rheol, mae Mastodon yn caniatáu i chi weld cynnwys gan unrhyw weinyddwr arall yn y ffedysawd a rhyngweithio â hi. Dyma'r eithriadau a wnaed ar y gweinydd penodol hwn.",
  "about.domain_blocks.silenced.explanation": "Fel rheol, fyddwch chi ddim yn gweld proffiliau a chynnwys o'r gweinydd hwn, oni bai eich bod yn chwilio'n benodol amdano neu yn ymuno drwy ei ddilyn.",
  "about.domain_blocks.silenced.title": "Cyfyngedig",
  "about.domain_blocks.suspended.explanation": "Fydd data o'r gweinydd hwn ddim yn cael ei brosesu, ei gadw na'i gyfnewid, gan wneud unrhyw ryngweithio neu gyfathrebu gyda defnyddwyr o'r gweinydd hwn yn amhosibl.",
  "about.domain_blocks.suspended.title": "Wedi'i atal",
  "about.language_label": "Iaith",
  "about.not_available": "Dyw'r wybodaeth yma heb ei wneud ar gael ar y gweinydd hwn.",
  "about.powered_by": "Cyfrwng cymdeithasol datganoledig wedi ei yrru gan {mastodon}",
  "about.rules": "Rheolau'r gweinydd",
  "account.account_note_header": "Nodyn personol",
  "account.activity": "Gweithgaredd",
  "account.add_note": "Ychwanegu nodyn personol",
  "account.add_or_remove_from_list": "Ychwanegu neu Ddileu o'r rhestrau",
  "account.badges.admin": "Gweinyddwr",
  "account.badges.blocked": "Rhwystrwyd",
  "account.badges.bot": "Awtomataidd",
  "account.badges.domain_blocked": "Parth wedi'i rwystro",
  "account.badges.group": "Grŵp",
  "account.badges.muted": "Wedi'i Dewi",
  "account.badges.muted_until": "Wedi'i dewi tan {until}",
  "account.block": "Rhwystro @{name}",
  "account.block_domain": "Rhwystro'r parth {domain}",
  "account.block_short": "Rhwystro",
  "account.blocked": "Wedi'i rwystro",
  "account.cancel_follow_request": "Tynnu cais i ddilyn",
  "account.copy": "Copïo dolen i'r proffil",
  "account.direct": "Crybwyll yn breifat @{name}",
  "account.disable_notifications": "Stopiwch fy hysbysu pan fydd @{name} yn postio",
  "account.edit_note": "Golygu nodyn personol",
  "account.edit_profile": "Golygu'r proffil",
  "account.edit_profile_short": "Golygu",
  "account.enable_notifications": "Rhowch wybod i fi pan fydd @{name} yn postio",
  "account.endorse": "Dangos ar fy mhroffil",
  "account.familiar_followers_many": "Yn cael ei ddilyn gan {name1},{name2}, a {othersCount, plural, one {one other you know} other{# others you know}}",
  "account.familiar_followers_one": "Wedi'i ddilyn gan {name1}",
  "account.familiar_followers_two": "Wedi'i ddilyn gan {name1} a {name2}",
  "account.featured": "Nodwedd",
  "account.featured.accounts": "Proffilau",
  "account.featured.collections": "Casgliadau",
  "account.featured.new_collection": "Casgliad newydd",
  "account.field_overflow": "Dangos cynnwys llawn",
  "account.filters.all": "Pob gweithgaredd",
  "account.filters.boosts_toggle": "Dangos hybiau",
  "account.filters.posts_boosts": "Postiadau a hybiau",
  "account.filters.posts_only": "Postiadau",
  "account.filters.posts_replies": "Postiadau ac atebion",
  "account.filters.replies_toggle": "Dangos atebion",
  "account.follow": "Dilyn",
  "account.follow_back": "Dilyn nôl",
  "account.follow_back_short": "Dilyn nôl",
  "account.follow_request": "Cais i ddilyn",
  "account.follow_request_cancel": "Diddymu cais",
  "account.follow_request_cancel_short": "Diddymu",
  "account.follow_request_short": "Gofyn",
  "account.followers": "Dilynwyr",
  "account.followers.empty": "Does neb yn dilyn y defnyddiwr hwn eto.",
  "account.followers_counter": "{count, plural, one {{counter} dilynwr} two {{counter} ddilynwr} other {{counter} dilynwr}}",
  "account.followers_you_know_counter": "{counter} rydych chi'n adnabod",
  "account.following": "Yn dilyn",
  "account.following_counter": "{count, plural, one {Yn dilyn {counter}} other {Yn dilyn {counter} arall}}",
  "account.follows.empty": "Dyw'r defnyddiwr hwn ddim yn dilyn unrhyw un eto.",
  "account.follows_you": "Yn eich dilyn chi",
  "account.go_to_profile": "Mynd i'r proffil",
  "account.hide_reblogs": "Cuddio hybiau gan @{name}",
  "account.in_memoriam": "Er Cof.",
  "account.join_modal.day": "Diwrnod",
  "account.join_modal.me": "Rydych wedi ymuno â {server} ar",
  "account.join_modal.me_anniversary": "Ffedysawd Hapus! Rydych wedi ymuno â {server} ar",
  "account.join_modal.me_today": "Dyma'ch diwrnod cyntaf ar {server}!",
  "account.join_modal.other": "Ymunodd {name} â {server} ar",
  "account.join_modal.other_today": "Mae'n diwrnod cyntaf {name} ar {server}!",
  "account.join_modal.share.celebrate": "Rhannwch bostiad dathlu",
  "account.join_modal.share.intro": "Rhannu postiad cyflwyno",
  "account.join_modal.share.welcome": "Rhannwch postiad croeso",
  "account.join_modal.years": "{number, plural, one {blwyddyn} other {blwyddyn}}",
  "account.joined_short": "Ymunodd",
  "account.languages": "Newid ieithoedd wedi tanysgrifio iddyn nhw",
  "account.last_active": "Yn weithgar ddiwethaf",
  "account.link_verified_on": "Gwiriwyd perchnogaeth y ddolen yma ar {date}",
  "account.locked_info": "Mae'r statws preifatrwydd cyfrif hwn wedi'i osod i fod ar glo. Mae'r perchennog yn adolygu'r sawl sy'n gallu eu dilyn.",
  "account.media": "Cyfryngau",
  "account.mention": "Crybwyll @{name}",
  "account.menu.add_to_list": "Ychwanegu at y rhestr…",
  "account.menu.block": "Rhwystro cyfrif",
  "account.menu.block_domain": "Rhwystro {domain}",
  "account.menu.copied": "Copïwyd dolen y cyfrif i'r clipfwrdd",
  "account.menu.copy": "Copïo dolen",
  "account.menu.direct": "Crybwyll yn breifat",
  "account.menu.hide_reblogs": "Cuddio hybiau yn yr llinell amser",
  "account.menu.mention": "Crybwyll",
  "account.menu.mute": "Tewi cyfrif",
  "account.menu.note.description": "Yn weladwy dim ond i chi",
  "account.menu.open_original_page": "Gweld ar {domain}",
  "account.menu.remove_follower": "Dileu dilynwr",
  "account.menu.report": "Adrodd ar gyfrif",
  "account.menu.share": "Rhannu…",
  "account.menu.show_reblogs": "Dangos hybiau yn y llinell amser",
  "account.menu.unblock": "Dadrwystro cyfrif",
  "account.menu.unblock_domain": "Dadrwystro {domain}",
  "account.menu.unmute": "Dadf-dewi cyfrif",
  "account.moved_to": "Mae {name} wedi nodi fod eu cyfrif newydd yn:",
  "account.mute": "Tewi @{name}",
  "account.mute_notifications_short": "Diffodd hysbysiadau",
  "account.mute_short": "Anwybyddu",
  "account.muted": "Wedi anwybyddu",
  "account.mutual": "Rydych chi'n dilyn eich gilydd",
  "account.name.copy": "Copïo dolen",
  "account.name.help.domain": "{domain} yw'r gweinydd sy'n cynnal proffil a phostiadau'r defnyddiwr.",
  "account.name.help.domain_self": "{domain} yw eich gweinydd sy'n cynnal eich proffil a'ch postiadau.",
  "account.name.help.footer": "Yn union fel y gallwch anfon negeseuon e-bost at bobl gan ddefnyddio gwahanol ddarparwyr e-bost, gallwch ryngweithio â phobl ar weinyddion Mastodon eraill, a chyda neb ar apiau Ffedysawd eraill.",
  "account.name.help.header": "Mae dolen fel cyfeiriad e-bost",
  "account.name.help.username": "{username} yw enw defnyddiwr y cyfrif hwn ar eu gweinydd. Efallai bod gan rywun ar weinydd arall yr un enw defnyddiwr.",
  "account.name.help.username_self": "{username} yw eich enw defnyddiwr ar y gweinydd hwn. Efallai bod gan rywun ar weinydd arall yr un enw defnyddiwr.",
  "account.name_info": "Beth mae hyn yn ei olygu?",
  "account.no_bio": "Dim disgrifiad wedi'i gynnig.",
  "account.node_modal.callout": "Dim ond chi sy'n gallu gweld nodiadau personol.",
  "account.node_modal.edit_title": "Golygu nodyn personol",
  "account.node_modal.error_unknown": "Methwyd cadw'r nodyn",
  "account.node_modal.field_label": "Nodyn Personol",
  "account.node_modal.save": "Cadw",
  "account.node_modal.title": "Ychwanegu nodyn personol",
  "account.note.edit_button": "Golygu",
  "account.note.title": "Nodyn personol (yn weladwy i chi yn unig)",
  "account.open_original_page": "Agor y dudalen wreiddiol",
  "account.pending": "Dan ystyriaeth",
  "account.posts": "Postiadau",
  "account.remove_from_followers": "Tynnu {name} o'ch dilynwyr",
  "account.report": "Adrodd @{name}",
  "account.requested_follow": "Mae {name} wedi gwneud cais i'ch dilyn",
  "account.share": "Rhannu proffil @{name}",
  "account.show_reblogs": "Dangos hybiau gan @{name}",
  "account.statuses_counter": "{count, plural, one {{counter} postiad} two {{counter} bostiad} few {{counter} phostiad} many {{counter} postiad} other {{counter} postiad}}",
  "account.timeline.pinned": "Wedi'i binio",
  "account.timeline.pinned.view_all": "Gweld pob postiad wedi'i binio",
  "account.unblock": "Dadrwystro @{name}",
  "account.unblock_domain": "Dadrwystro parth {domain}",
  "account.unblock_domain_short": "Dadrwystro",
  "account.unblock_short": "Dadrwystro",
  "account.unendorse": "Peidio a'i ddangos ar fy mhroffil",
  "account.unfollow": "Dad-ddilyn",
  "account.unmute": "Dad-dewi {name}",
  "account.unmute_notifications_short": "Dad-dewi hysbysiadau",
  "account.unmute_short": "Dad-anwybyddu",
  "account_edit.advanced_settings.bot_hint": "Rhoi arwydd i eraill bod y cyfrif yn bennaf yn cyflawni gweithredoedd awtomataidd ac efallai fydd e ddim yn cael ei fonitro",
  "account_edit.advanced_settings.bot_label": "Cyfrif awtomataidd",
  "account_edit.advanced_settings.title": "Gosodiadau uwch",
  "account_edit.bio.add_label": "Ychwanegu cyflwyniad",
  "account_edit.bio.edit_label": "Golygu'r cyflwyniad",
  "account_edit.bio.placeholder": "Ychwanegwch gyflwyniad byr i helpu eraill i'ch adnabod chi.",
  "account_edit.bio.title": "Cyflwyniad",
  "account_edit.bio_modal.add_title": "Ychwanegu cyflwyniad",
  "account_edit.bio_modal.edit_title": "Golygu'r cyflwyniad",
  "account_edit.column_button": "Gorffen",
  "account_edit.column_title": "Golygu Proffil",
  "account_edit.custom_fields.add_label": "Ychwanegu maes",
  "account_edit.custom_fields.edit_label": "Golygu maes",
  "account_edit.custom_fields.placeholder": "Ychwanegwch eich rhagenwau, dolenni allanol, neu unrhyw beth arall hoffech ei rannu.",
  "account_edit.custom_fields.reorder_button": "Ail-drefnu meysydd",
  "account_edit.custom_fields.tip_content": "Gallwch chi ychwanegu hygrededd at eich cyfrif Mastodon yn hawdd trwy wirio dolenni i unrhyw wefannau rydych chi'n berchen arnyn nhw.",
  "account_edit.custom_fields.tip_title": "Awgrym: Ychwanegu dolenni wedi'u gwirio",
  "account_edit.custom_fields.title": "Meysydd cyfaddas",
  "account_edit.custom_fields.verified_hint": "Sut ydw i'n ychwanegu dolen wedi'i gwirio?",
  "account_edit.display_name.add_label": "Ychwanegu enw dangos",
  "account_edit.display_name.edit_label": "Golygu enw dangos",
  "account_edit.display_name.placeholder": "Eich enw dangos yw sut mae'ch enw'n ymddangos ar eich proffil ac mewn llinellau amser.",
  "account_edit.display_name.title": "Enw dangos",
  "account_edit.featured_hashtags.edit_label": "Ychwanegu hashnodau",
  "account_edit.featured_hashtags.placeholder": "Helpwch eraill i adnabod, a chael mynediad cyflym at eich hoff bynciau.",
  "account_edit.featured_hashtags.title": "Hashnodau dan sylw",
  "account_edit.field_actions.delete": "Dileu maes",
  "account_edit.field_actions.edit": "Golygu maes",
  "account_edit.field_delete_modal.confirm": "Ydych chi'n siŵr eich bod chi eisiau dileu'r maes cyfaddas hwn? Does dim modd dadwneud y weithred hon.",
  "account_edit.field_delete_modal.delete_button": "Dileu",
  "account_edit.field_delete_modal.title": "Dileu maes cyfaddas?",
  "account_edit.field_edit_modal.add_title": "Ychwanegu maes cyfaddas",
  "account_edit.field_edit_modal.discard_confirm": "Dileu",
  "account_edit.field_edit_modal.discard_message": "Mae gennych chi newidiadau heb eu cadw. Ydych chi'n siŵr eich bod chi eisiau eu dileu?",
  "account_edit.field_edit_modal.edit_title": "Golygu maes cyfaddas",
  "account_edit.field_edit_modal.length_warning": "Wedi mynd y tu hwnt i'r terfyn nodau sy'n cael eu hargymell. Efallai bydd defnyddwyr symudol ddim yn gweld eich maes yn llawn.",
  "account_edit.field_edit_modal.link_emoji_warning": "Rydym yn argymell yn erbyn defnyddio emoji personol ar y cyd ag URLau. Bydd meysydd personol sy'n cynnwys y ddau yn cael eu harddangos fel testun yn unig yn hytrach nag fel dolen, er mwyn atal dryswch ymhlith defnyddwyr.",
  "account_edit.field_edit_modal.name_hint": "e.e. “Gwefan bersonol”",
  "account_edit.field_edit_modal.name_label": "Label",
  "account_edit.field_edit_modal.url_warning": "I ychwanegu dolen, cofiwch gynnwys {protocol} ar y dechrau.",
  "account_edit.field_edit_modal.value_hint": "E.e. “https://example.me”",
  "account_edit.field_edit_modal.value_label": "Gwerth",
  "account_edit.field_reorder_modal.drag_cancel": "Cafodd y llusgo ei ddiddymu. Cafodd y maes \"{item}\" ei ollwng.",
  "account_edit.field_reorder_modal.drag_end": "Cafodd y maes \"{item}\" ei ollwng.",
  "account_edit.field_reorder_modal.drag_instructions": "I aildrefnu meysydd cyfaddas, pwyswch y bylchwr neu enter. Wrth lusgo, defnyddiwch y bysellau saeth i symud y maes i fyny neu i lawr. Pwyswch y bylchwr neu enter eto i ollwng y maes yn ei safle newydd, neu pwyswch escape i'w ddiddymu.",
  "account_edit.field_reorder_modal.drag_move": "Symudwyd y maes \"{item}\".",
  "account_edit.field_reorder_modal.drag_over": "Symudwyd y maes \"{item}\" dros \"{over}\".",
  "account_edit.field_reorder_modal.drag_start": "Wedi codi maes \"{item}\".",
  "account_edit.field_reorder_modal.handle_label": "Llusgo'r maes \"{item}\"",
  "account_edit.field_reorder_modal.title": "Aildrefnu meysydd",
  "account_edit.image_alt_modal.add_title": "Ychwanegu testun amgen",
  "account_edit.image_alt_modal.details_content": "GWNEUD:<ul><li> Disgrifio'ch hun fel yn eich llun</li><li> Defnyddio iaith trydydd person (e.e. “Siôn” yn lle “fi”)</li><li> Bod yn gryno – mae ychydig o eiriau’n aml yn ddigon</li></ul> PEIDIO:<ul><li> Dechrau gyda “Llun o” – mae’n ddiangen ar gyfer darllenwyr sgrin</li></ul> ENGHRAIFFT:<ul><li> “Dyma Siôn yn gwisgo crys gwyrdd a sbectol”</li></ul>",
  "account_edit.image_alt_modal.details_title": "Awgrymiadau: Testun amgen ar gyfer lluniau proffil",
  "account_edit.image_alt_modal.edit_title": "Golygu testun amgen",
  "account_edit.image_alt_modal.text_hint": "Mae testun amgen yn helpu defnyddwyr darllenwyr sgrin i ddeall eich cynnwys.",
  "account_edit.image_alt_modal.text_label": "Testun amgen",
  "account_edit.image_delete_modal.confirm": "Ydych chi'n siŵr eich bod chi eisiau dileu'r ddelwedd hon? Does dim modd dadwneud hynny.",
  "account_edit.image_delete_modal.delete_button": "Dileu",
  "account_edit.image_delete_modal.title": "Dileu delwedd?",
  "account_edit.image_edit.add_button": "Ychwanegu Delwedd",
  "account_edit.image_edit.alt_add_button": "Ychwanegu testun amgen",
  "account_edit.image_edit.alt_edit_button": "Golygu testun amgen",
  "account_edit.image_edit.remove_button": "Tynnu delwedd",
  "account_edit.image_edit.replace_button": "Amnewid delwedd",
  "account_edit.item_list.delete": "Dileu {name}",
  "account_edit.item_list.edit": "Golygu {name}",
  "account_edit.name_modal.add_title": "Ychwanegu enw dangos",
  "account_edit.name_modal.edit_title": "Golygu enw dangos",
  "account_edit.profile_tab.button_label": "Cyfaddasu",
  "account_edit.profile_tab.hint.description": "Mae'r gosodiadau hyn yn cyfaddasu'r hyn y mae defnyddwyr yn ei weld ar {server} yn yr apiau swyddogol, ond efallai fyddan nhw ddim yn berthnasol i ddefnyddwyr ar weinyddion eraill ac apiau trydydd parti.",
  "account_edit.profile_tab.hint.title": "Mae'r dangosyddion yn dal i amrywio",
  "account_edit.profile_tab.show_featured.description": "Tab dewisol yw ‘Nodwedd’ lle gallwch ddangos cyfrifon eraill.",
  "account_edit.profile_tab.show_featured.title": "Dangos y tab ‘Nodwedd’",
  "account_edit.profile_tab.show_media.description": "Tab dewisol yw ‘Cyfryngau’ sy’n dangos eich postiadau sy’n cynnwys delweddau neu fideos.",
  "account_edit.profile_tab.show_media.title": "Dangos y tab ‘Cyfryngau’",
  "account_edit.profile_tab.show_media_replies.description": "Pan fydd wedi'i alluogi, mae'r tab Cyfryngau yn dangos eich postiadau ac atebion i bostiadau pobl eraill.",
  "account_edit.profile_tab.show_media_replies.title": "Cynhwyswch atebion ar y tab ‘Cyfryngau’",
  "account_edit.profile_tab.show_relations.description": "Yn dangos cyfrifon rydych chi'n eu dilyn a dilynwyr i ddefnyddwyr eraill yn eich proffil. Bydd pobl yn dal i allu gweld a ydych chi'n eu dilyn.",
  "account_edit.profile_tab.show_relations.title": "Dangos ‘Dilynwyr’ ac ‘Yn Dilyn’",
  "account_edit.profile_tab.subtitle": "Cyfaddaswch sut mae eich proffil yn cael ei ddangos.",
  "account_edit.profile_tab.title": "Gosodiadau dangos proffil",
  "account_edit.save": "Cadw",
  "account_edit.upload_modal.back": "Nôl",
  "account_edit.upload_modal.done": "Gorffen",
  "account_edit.upload_modal.next": "Nesaf",
  "account_edit.upload_modal.step_crop.zoom": "Chwyddo",
  "account_edit.upload_modal.step_upload.button": "Pori ffeiliau",
  "account_edit.upload_modal.step_upload.dragging": "Gollwng i lwytho i fyny",
  "account_edit.upload_modal.step_upload.header": "Dewiswch ddelwedd",
  "account_edit.upload_modal.step_upload.hint": "Fformat WEBP, PNG, GIF neu JPG, hyd at {limit}MB.{br}Bydd y ddelwedd yn cael ei haddasu i {width}x{height}px.",
  "account_edit.upload_modal.title_add.avatar": "Ychwanegu llun proffil",
  "account_edit.upload_modal.title_add.header": "Ychwanegu llun clawr",
  "account_edit.upload_modal.title_replace.avatar": "Amnewid llun proffil",
  "account_edit.upload_modal.title_replace.header": "Amnewid llun clawr",
  "account_edit.verified_modal.details": "Ychwanegwch hygrededd at eich proffil Mastodon trwy wirio dolenni i wefannau personol. Dyma sut mae'n gweithio:",
  "account_edit.verified_modal.invisible_link.details": "Ychwanegwch y ddolen at eich pennyn. Y rhan bwysig yw rel=\"me\" sy'n atal dynwared ar wefannau gyda chynnwys sy'n cael ei gynhyrchu gan ddefnyddwyr. Gallwch hyd yn oed ddefnyddio tag dolen ym mhennyn y dudalen yn lle {tag}, ond rhaid bod yr HTML yn hygyrch ac heb weithredu JavaScript.",
  "account_edit.verified_modal.invisible_link.summary": "Sut ydw i'n gwneud y ddolen yn anweledig?",
  "account_edit.verified_modal.step1.header": "Copïwch y cod HTML isod a'i gludo i bennyn eich gwefan",
  "account_edit.verified_modal.step2.details": "Os ydych chi eisoes wedi ychwanegu eich gwefan fel maes cyfaddas, bydd angen i chi ei dileu a'i hail-ychwanegu i cychwyn dilysu.",
  "account_edit.verified_modal.step2.header": "Ychwanegwch eich gwefan fel maes cyfaddas",
  "account_edit.verified_modal.title": "Sut i ychwanegu dolen wedi'i gwirio",
  "account_edit_tags.add_tag": "Ychwanegu #{tagName}",
  "account_edit_tags.column_title": "Golygu Tagiau",
  "account_edit_tags.help_text": "Mae hashnodau dan sylw yn helpu defnyddwyr i ddarganfod a rhyngweithio â'ch proffil. Maen nhw'n ymddangos fel hidlwyr ar olwg Gweithgaredd eich tudalen Proffil.",
  "account_edit_tags.max_tags_reached": "Rydych chi wedi cyrraedd y nifer uchaf o hashnodau dan sylw.",
  "account_edit_tags.search_placeholder": "Rhowch hashnod…",
  "account_edit_tags.suggestions": "Awgrymiadau:",
  "account_edit_tags.tag_status_count": "{count, plural, one {# postiad} other {# postsiad}}",
  "account_list.hidden_notice": "Dim ond chi sy'n gallu gweld hyn. I ddangos y rhestr hon i eraill, ewch i<link> {page} > {modal} > {field}</link> .",
  "account_list.total": "{total, plural, one {# cyfrif} other {# cyfrif}}",
  "account_note.placeholder": "Clicio i ychwanegu nodyn",
  "admin.dashboard.daily_retention": "Cyfradd cadw defnyddwyr fesul diwrnod ar ôl cofrestru",
  "admin.dashboard.monthly_retention": "Cyfradd cadw defnyddwyr fesul mis ar ôl cofrestru",
  "admin.dashboard.retention.average": "Cyfartaledd",
  "admin.dashboard.retention.cohort": "Mis cofrestru",
  "admin.dashboard.retention.cohort_size": "Defnyddwyr newydd",
  "admin.impact_report.instance_accounts": "Proffiliau cyfrifon y byddai hyn yn eu dileu",
  "admin.impact_report.instance_followers": "Dilynwyr byddai ein defnyddwyr yn colli",
  "admin.impact_report.instance_follows": "Dilynwyr byddai eu defnyddwyr yn colli",
  "admin.impact_report.title": "Crynodeb effaith",
  "alert.rate_limited.message": "Ceisiwch eto ar ôl {retry_time, time, medium}.",
  "alert.rate_limited.title": "Cyfradd gyfyngedig",
  "alert.unexpected.message": "Digwyddodd gwall annisgwyl.",
  "alert.unexpected.title": "Wps!",
  "alt_text_badge.title": "Testun amgen",
  "alt_text_modal.add_alt_text": "Ychwanegu testun amgen",
  "alt_text_modal.add_text_from_image": "Ychwanegu testun o'r ddelwedd",
  "alt_text_modal.cancel": "Diddymu",
  "alt_text_modal.change_thumbnail": "Newid llun bach",
  "alt_text_modal.describe_for_people_with_hearing_impairments": "Disgrifiwch hyn ar gyfer pobl â nam ar eu clyw…",
  "alt_text_modal.describe_for_people_with_visual_impairments": "Disgrifiwch hyn ar gyfer pobl â nam ar eu golwg…",
  "alt_text_modal.done": "Gorffen",
  "announcement.announcement": "Cyhoeddiad",
  "annual_report.announcement.action_build": "Adeiladu fy Wrapstodon",
  "annual_report.announcement.action_dismiss": "Dim diolch",
  "annual_report.announcement.action_view": "Gweld fy Wrapstodon",
  "annual_report.announcement.description": "Darganfod mwy am eich ymgysylltiad â Mastodon dros y flwyddyn ddiwethaf.",
  "annual_report.announcement.title": "Mae Wrapstodon {year} wedi cyrraedd",
  "annual_report.nav_item.badge": "Newydd",
  "annual_report.shared_page.donate": "Cyfrannu",
  "annual_report.shared_page.footer": "Wedi'i gynhyrchu gyda {heart} gan dîm Mastodon",
  "annual_report.shared_page.footer_server_info": "Mae {username} yn defnyddio {domain}, un o nifer o gymunedau sy'n cael eu pweru gan Mastodon.",
  "annual_report.summary.archetype.booster.desc_public": "Parhaodd {name} i chwilio am bostiadau i'w hybu, gan hyrwyddo crewyr eraill yn effeithiol.",
  "annual_report.summary.archetype.booster.desc_self": "Fe wnaethoch chi aros ar y chwilio am bostiadau i'w hybu, gan chwyddo crewyr eraill yn effeithiol.",
  "annual_report.summary.archetype.booster.name": "Y Saethydd",
  "annual_report.summary.archetype.die_drei_fragezeichen": "???",
  "annual_report.summary.archetype.lurker.desc_public": "Rydyn ni'n gwybod bod {name} allan yna, yn rhywle, yn mwynhau Mastodon yn eu ffordd dawel eu hunain.",
  "annual_report.summary.archetype.lurker.desc_self": "Rydyn ni'n gwybod eich bod chi allan yna, yn rhywle, yn mwynhau Mastodon yn eich ffordd dawel eich hun.",
  "annual_report.summary.archetype.lurker.name": "Y Stoicaidd",
  "annual_report.summary.archetype.oracle.desc_public": "Creodd {name} fwy o bostiadau newydd nag atebion, gan gadw Mastodon yn ffres ac yn edrych i'r dyfodol.",
  "annual_report.summary.archetype.oracle.desc_self": "Fe wnaethoch chi greu mwy o bostiadau newydd nag atebion, gan gadw Mastodon yn ffres ac yn edrych i'r dyfodol.",
  "annual_report.summary.archetype.oracle.name": "Yr Oracl",
  "annual_report.summary.archetype.pollster.desc_public": "Creodd {name} fwy o arolygon barn na mathau eraill o bostiadau, gan feithrin chwilfrydedd am Mastodon.",
  "annual_report.summary.archetype.pollster.desc_self": "Fe greoch chi fwy o arolygon barn na mathau eraill o bostiadau, gan feithrin chwilfrydedd ar Mastodon.",
  "annual_report.summary.archetype.pollster.name": "Y Syfrdanwr",
  "annual_report.summary.archetype.replier.desc_public": "Roedd {name} yn aml yn ymateb i bostiadau pobl eraill, gan beillio Mastodon gyda thrafodaethau newydd.",
  "annual_report.summary.archetype.replier.desc_self": "Roeddech chi'n aml yn ymateb i bostiadau pobl eraill, gan hau Mastodon gyda thrafodaethau newydd.",
  "annual_report.summary.archetype.replier.name": "Y Pili-pala",
  "annual_report.summary.archetype.reveal": "Datgelu fy nhuedd",
  "annual_report.summary.archetype.reveal_description": "Diolch am fod yn rhan o Mastodon! Amser darganfod pa duedd oeddech chi'n ei ymgorffori yn {year}.",
  "annual_report.summary.archetype.title_public": "Tuedd {name}",
  "annual_report.summary.archetype.title_self": "Eich tuedd",
  "annual_report.summary.close": "Cau",
  "annual_report.summary.copy_link": "Copïo dolen",
  "annual_report.summary.followers.new_followers": "{count, plural, one {dilynwr newydd} other {dilynwr newydd}}",
  "annual_report.summary.highlighted_post.boost_count": "Cafodd y postiad hwn hwb {count, plural, one {unwaith} other {# gwaith}}.",
  "annual_report.summary.highlighted_post.favourite_count": "Cafodd y postiad hwn ei ffefrynnu {count, plural, one {waith} other {# gwaith}}.",
  "annual_report.summary.highlighted_post.reply_count": "Cafodd y post hwn {count, plural, one {un ateb} other {# ateb}}.",
  "annual_report.summary.highlighted_post.title": "Postiad mwyaf poblogaidd",
  "annual_report.summary.most_used_app.most_used_app": "ap a ddefnyddiwyd fwyaf",
  "annual_report.summary.most_used_hashtag.most_used_hashtag": "hashnod a ddefnyddiwyd fwyaf",
  "annual_report.summary.most_used_hashtag.used_count": "Fe wnaethoch chi gynnwys yr hashnod hwn yn {count, plural, one {un postiad} other {# postiad}}.",
  "annual_report.summary.most_used_hashtag.used_count_public": "Mae {name} wedi cynnwys yr hashnod hwn yn {count, plural, one {un postiad} other {# postiad}}.",
  "annual_report.summary.new_posts.new_posts": "postiadau newydd",
  "annual_report.summary.percentile.text": "<topLabel>Mae hynny'n eich rhoi chi ymysg y</topLabel><percentage></percentage><bottomLabel>uchaf o ddefnyddwyr {domain}.</bottomLabel>",
  "annual_report.summary.percentile.we_wont_tell_bernie": "Fyddwn ni ddim yn dweud wrth Bernie.",
  "annual_report.summary.share_elsewhere": "Rhannu mewn mannau eraill",
  "annual_report.summary.share_message": "Fy arddull i yw {archetype}!",
  "annual_report.summary.share_on_mastodon": "Rhannwch ar Mastodon",
  "attachments_list.unprocessed": "(heb eu prosesu)",
  "audio.hide": "Cuddio sain",
  "block_modal.remote_users_caveat": "Byddwn yn gofyn i'r gweinydd {domain} barchu eich penderfyniad. Fodd bynnag, nid yw cydymffurfiad wedi'i warantu gan y gall rhai gweinyddwyr drin rhwystrau mewn ffyrdd gwahanol. Mae'n bosibl y bydd postiadau cyhoeddus yn dal i fod yn weladwy i ddefnyddwyr nad ydynt wedi mewngofnodi.",
  "block_modal.show_less": "Dangos llai",
  "block_modal.show_more": "Dangos rhagor",
  "block_modal.they_will_know": "Gallan nhw weld eu bod wedi'u rhwystro.",
  "block_modal.title": "Blocio defnyddiwr?",
  "boost_modal.combo": "Mae modd pwyso {combo} er mwyn hepgor hyn tro nesa",
  "boost_modal.reblog": "Hybu postiad?",
  "boost_modal.undo_reblog": "Dad-hybu postiad?",
  "bundle_column_error.copy_stacktrace": "Copïo'r adroddiad gwall",
  "bundle_column_error.error.body": "Does dim modd cynhyrchu'r dudalen honno. Gall fod oherwydd gwall yn ein cod neu fater cydnawsedd porwr.",
  "bundle_column_error.error.title": "O na!",
  "bundle_column_error.network.body": "Bu gwall wrth geisio llwytho'r dudalen hon. Gall hyn fod oherwydd anhawster dros-dro gyda'ch cysylltiad gwe neu'r gweinydd hwn.",
  "bundle_column_error.network.title": "Gwall rhwydwaith",
  "bundle_column_error.retry": "Ceisiwch eto",
  "bundle_column_error.return": "Mynd i'r ffrwd gartref",
  "bundle_column_error.routing.body": "Doedd dim modd canfod y dudalen honno. Ydych chi'n siŵr fod yr URL yn y bar cyfeiriad yn gywir?",
  "bundle_column_error.routing.title": "404",
  "bundle_modal_error.close": "Cau",
  "bundle_modal_error.message": "Aeth rhywbeth o'i le wrth lwytho'r sgrin hon.",
  "bundle_modal_error.retry": "Ceisiwch eto",
  "callout.dismiss": "Cau",
  "carousel.current": "<sr>Sleid</sr> {current, number} / {max, number}",
  "carousel.slide": "Sleid {current, number} o {max, number}",
  "character_counter.recommended": "{currentLength}/{maxLength} nod sy'n cael eu hargymell",
  "character_counter.required": "{currentLength}/{maxLength} nod",
  "closed_registrations.other_server_instructions": "Gan fod Mastodon yn ddatganoledig, gallwch greu cyfrif ar weinydd arall a dal i ryngweithio gyda hwn.",
  "closed_registrations_modal.description": "Ar hyn o bryd nid yw'n bosib creu cyfrif ar {domain}, ond cadwch mewn cof nad oes raid i chi gael cyfrif yn benodol ar {domain} i ddefnyddio Mastodon.",
  "closed_registrations_modal.find_another_server": "Dod o hyd i weinydd arall",
  "closed_registrations_modal.preamble": "Mae Mastodon wedi'i ddatganoli, felly does dim gwahaniaeth ble rydych chi'n creu eich cyfrif, byddwch chi'n gallu dilyn a rhyngweithio ag unrhyw un ar y gweinydd hwn. Gallwch hyd yn oed ei gynnal un eich hun!",
  "closed_registrations_modal.title": "Cofrestru ar Mastodon",
  "collection.share_modal.share_link_label": "Rhannu dolen",
  "collection.share_modal.share_via_post": "Postio ar Mastodon",
  "collection.share_modal.share_via_system": "Rhannwch i…",
  "collection.share_modal.title": "Rhannu casgliad",
  "collection.share_modal.title_new": "Rhannwch eich casgliad newydd!",
  "collection.share_template_other": "Edrychwch ar y casgliad trawiadol hwn: {link}",
  "collection.share_template_own": "Edrychwch ar fy nghasgliad newydd: {link}",
  "collections.account_count": "{count, plural, one {# cyfrif} other {# cyfrif}}",
  "collections.accounts.empty_description": "Ychwanegu hyd at {count} cyfrif",
  "collections.accounts.empty_editor_title": "Does neb yn y casgliad hwn eto",
  "collections.accounts.empty_title": "Mae'r casgliad hwn yn wag",
  "collections.block_collection_owner": "Rhwystro cyfrif",
  "collections.by_account": "gan {account_handle}",
  "collections.collection_description": "Disgrifiad",
  "collections.collection_language": "Iaith",
  "collections.collection_language_none": "Dim",
  "collections.collection_name": "Enw",
  "collections.collection_topic": "Pwnc",
  "collections.confirm_account_removal": "Ydych chi'n siŵr eich bod chi eisiau tynnu'r cyfrif hwn o'r casgliad hwn?",
  "collections.content_warning": "Rhybudd cynnwys",
  "collections.continue": "Parhau",
  "collections.copy_link": "Copïo dolen",
  "collections.copy_link_confirmation": "Copïwyd dolen y casgliad i'r clipfwrdd",
  "collections.create.accounts_title": "Pwy fyddwch chi'n ei gynnwys yn y casgliad hwn?",
  "collections.create.basic_details_title": "Manylion sylfaenol",
  "collections.create.steps": "Cam {step}/{total}",
  "collections.create_collection": "Creu casgliad",
  "collections.delete_collection": "Dileu casgliad",
  "collections.description_length_hint": "Terfyn o 100 nod",
  "collections.detail.author_added_you_on_date": "Ychwanegodd {author} chi ar {date}",
  "collections.detail.loading": "Yn llwytho casgliad…",
  "collections.detail.revoke_inclusion": "Tynnu fi",
  "collections.detail.sensitive_content": "Cynnwys sensitif",
  "collections.detail.sensitive_note": "Mae'r casgliad hwn yn cynnwys cyfrifon a chynnwys a allai fod yn sensitif i rai defnyddwyr.",
  "collections.detail.share": "Rhannu'r casgliad hwn",
  "collections.detail.you_are_in_this_collection": "Rydych chi wedi'ch cynnwys yn y casgliad hwn",
  "collections.edit_details": "Golygu manylion",
  "collections.error_loading_collections": "Bu gwall wrth geisio llwytho'r casgliadau hyn.",
  "collections.hidden_accounts_description": "Rydych chi wedi'ch rhwystro neu mudo {count, plural, one {defnyddiwr} other {defnyddiwr}}",
  "collections.hidden_accounts_link": "{count, plural, one {# cyfrif cudd} other {# cyfrif cudd}}",
  "collections.hints.accounts_counter": "{count} / {max} cyfrif",
  "collections.last_updated_at": "Diweddarwyd ddiwethaf: {date}",
  "collections.list.collections_with_count": "{count, plural, one {# Casgliad} other {# Casgliad}}",
  "collections.list.created_by_author": "Crëwyd gan {name}",
  "collections.list.created_by_you": "Crëwyd gan gennych chi",
  "collections.list.featuring_you": "Yn eich cynnwys chi",
  "collections.manage_accounts": "Rheoli cyfrifon",
  "collections.mark_as_sensitive": "Marcio fel sensitif",
  "collections.mark_as_sensitive_hint": "Yn cuddio disgrifiad a chyfrifon y casgliad y tu ôl i rybudd cynnwys. Bydd enw'r casgliad yn dal i fod yn weladwy.",
  "collections.maximum_collection_count_description": "Mae eich gweinydd yn caniatáu creu hyd at {count} o gasgliadau.",
  "collections.maximum_collection_count_reached": "Rydych chi wedi creu'r nifer mwyaf o gasgliadau",
  "collections.name_length_hint": "Terfyn o 40 nod",
  "collections.new_collection": "Casgliad newydd",
  "collections.pending_accounts.message": "Gall cyfrifon ymddangos fel rhai sydd ar y gweill pan fyddwn yn aros am ymateb gan y defnyddiwr neu ei weinydd. Dim ond chi all weld cyfrifon sydd ar y gweill.",
  "collections.pending_accounts.title": "Pam rydw i'n gweld cyfrifon sydd ar y gweill?",
  "collections.remove_account": "Tynnu",
  "collections.report_collection": "Adroddwch am y casgliad hwn",
  "collections.revoke_collection_inclusion": "Tynnu fy hun o'r casgliad hwn",
  "collections.revoke_inclusion.confirmation": "Rydych chi wedi cael eich tynnu o \"{collection}\"",
  "collections.revoke_inclusion.error": "Bu gwall, ceisiwch eto yn nes ymlaen.",
  "collections.search_accounts_label": "Chwiliwch am gyfrif i'w ychwanegu",
  "collections.search_accounts_max_reached": "Rydych chi wedi ychwanegu'r nifer mwyaf o gyfrifon",
  "collections.sensitive": "Sensitif",
  "collections.share_short": "Rhannu",
  "collections.suggestions.can_not_add": "Dim modd ei ychwanegu",
  "collections.suggestions.can_not_add_desc": "Efallai bod y cyfrifon hyn wedi dewis peidio â chael eu darganfod, neu efallai eu bod ar weinydd nad yw'n cefnogi casgliadau.",
  "collections.suggestions.must_follow": "Rhaid dilyn yn gyntaf",
  "collections.suggestions.must_follow_desc": "Mae'r cyfrifon hyn yn adolygu pob cais dilyn. Gall dilynwyr eu hychwanegu at gasgliadau.",
  "collections.topic_hint": "Ychwanegwch hashnod sy'n helpu eraill i ddeall prif bwnc y casgliad hwn.",
  "collections.topic_special_chars_hint": "Bydd nodau arbennig yn cael eu tynnu wrth gadw",
  "collections.unlisted_collections_description": "Nid yw'r rhain yn ymddangos ar eich proffil i eraill. Gall unrhyw un sydd â'r ddolen eu darganfod.",
  "collections.unlisted_collections_with_count": "Casgliadau heb eu rhestru ({count})",
  "collections.view_collection": "Gweld y casgliad",
  "collections.visibility_public": "Cyhoeddus",
  "collections.visibility_public_hint": "Mae modd eu canfod mewn canlyniadau chwilio a mannau eraill lle mae argymhellion yn ymddangos.",
  "collections.visibility_title": "Gwelededd",
  "collections.visibility_unlisted": "Heb ei restru",
  "collections.visibility_unlisted_hint": "Yn weladwy i unrhyw un sydd â dolen. Wedi'i guddio o ganlyniadau chwilio ac argymhellion.",
  "column.about": "Ynghylch",
  "column.blocks": "Defnyddwyr wedi'u rhwystro",
  "column.bookmarks": "Llyfrnodau",
  "column.community": "Ffrwd lleol",
  "column.create_list": "Creu rhestr",
  "column.direct": "Crybwylliadau preifat",
  "column.directory": "Pori proffiliau",
  "column.domain_blocks": "Parthau wedi'u rhwystro",
  "column.edit_list": "Golygu rhestr",
  "column.favourites": "Ffefrynnau",
  "column.firehose": "Ffrydiau byw",
  "column.firehose_local": "Ffrwd fyw ar gyfer y gweinydd hwn",
  "column.firehose_singular": "Ffrwd fyw",
  "column.follow_requests": "Ceisiadau dilyn",
  "column.home": "Cartref",
  "column.list_members": "Rheoli aelodau rhestr",
  "column.lists": "Rhestrau",
  "column.mutes": "Defnyddwyr wedi'u tewi",
  "column.notifications": "Hysbysiadau",
  "column.other_collections": "Casgliadau gan {name}",
  "column.pins": "Postiadau wedi eu pinio",
  "column.public": "Ffrwd y ffederasiwn",
  "column.your_collections": "Eich Casgliadau",
  "column_back_button.label": "Nôl",
  "column_header.hide_settings": "Cuddio'r dewisiadau",
  "column_header.moveLeft_settings": "Symud y golofn i'r chwith",
  "column_header.moveRight_settings": "Symud y golofn i'r dde",
  "column_header.pin": "Pinio",
  "column_header.show_settings": "Dangos gosodiadau",
  "column_header.unpin": "Dadbinio",
  "column_search.cancel": "Diddymu",
  "combobox.close_results": "Cau canlyniadau",
  "combobox.loading": "Yn llwytho",
  "combobox.no_results_found": "Dim canlyniadau ar gyfer y chwilio hwn",
  "combobox.open_results": "Agor canlyniadau",
  "combobox.results_available": "{count, plural, one {# awgrym} other {# awgrym}} ar gael. Defnyddiwch y saethau i fyny ac i lawr i lywio. Pwyswch y fysell Enter i ddewis.",
  "community.column_settings.local_only": "Lleol yn unig",
  "community.column_settings.media_only": "Cyfryngau yn unig",
  "community.column_settings.remote_only": "Pell yn unig",
  "compose.error.blank_post": "Gall postiad ddim bod yn wag.",
  "compose.language.change": "Newid iaith",
  "compose.language.search": "Chwilio ieithoedd...",
  "compose.published.body": "Postiad wedi ei gyhoeddi.",
  "compose.published.open": "Agor",
  "compose.saved.body": "Postiad wedi'i gadw.",
  "compose_form.direct_message_warning_learn_more": "Dysgu mwy",
  "compose_form.encryption_warning": "Dyw postiadau ar Mastodon ddim wedi'u hamgryptio o ben i ben. Peidiwch â rhannu unrhyw wybodaeth sensitif dros Mastodon.",
  "compose_form.hashtag_warning": "Fydd y postiad hwn ddim wedi'i restru o dan unrhyw hashnod gan nad yw'n gyhoeddus. Dim ond postiadau cyhoeddus y mae modd eu chwilio drwy hashnod.",
  "compose_form.lock_disclaimer": "Nid yw eich cyfri wedi'i {locked}. Gall unrhyw un eich dilyn i weld eich postiadau dilynwyr-yn-unig.",
  "compose_form.lock_disclaimer.lock": "wedi ei gloi",
  "compose_form.placeholder": "Beth sydd ar eich meddwl?",
  "compose_form.poll.duration": "Cyfnod pleidlais",
  "compose_form.poll.multiple": "Dewis lluosog",
  "compose_form.poll.option_placeholder": "Dewis {number}",
  "compose_form.poll.single": "Dewis unigol",
  "compose_form.poll.switch_to_multiple": "Newid pleidlais i adael mwy nag un dewis",
  "compose_form.poll.switch_to_single": "Newid pleidlais i gyfyngu i un dewis",
  "compose_form.poll.type": "Arddull",
  "compose_form.publish": "Postio",
  "compose_form.reply": "Ymateb",
  "compose_form.save_changes": "Diweddaru",
  "compose_form.spoiler.marked": "Dileu rhybudd cynnwys",
  "compose_form.spoiler.unmarked": "Ychwanegu rhybudd cynnwys",
  "compose_form.spoiler_placeholder": "Rhybudd cynnwys (dewisol)",
  "confirmation_modal.cancel": "Canslo",
  "confirmations.block.confirm": "Rhwystro",
  "confirmations.delete.confirm": "Dileu",
  "confirmations.delete.message": "Ydych chi'n sicr eich bod eisiau dileu y post hwn?",
  "confirmations.delete.title": "Dileu postiad?",
  "confirmations.delete_collection.confirm": "Dileu",
  "confirmations.delete_collection.message": "Does dim modd dadwneud y weithred hon.",
  "confirmations.delete_collection.title": "Dileu \"{name}\"?",
  "confirmations.delete_list.confirm": "Dileu",
  "confirmations.delete_list.message": "Ydych chi'n siŵr eich bod eisiau dileu'r rhestr hwn am byth?",
  "confirmations.delete_list.title": "Dileu rhestr?",
  "confirmations.discard_draft.confirm": "Dileu a pharhau",
  "confirmations.discard_draft.edit.cancel": "Ail-ddechrau golygu",
  "confirmations.discard_draft.edit.message": "Bydd parhau yn dileu unrhyw newidiadau rydych chi wedi'u gwneud i'r postiad rydych chi'n ei olygu ar hyn o bryd.",
  "confirmations.discard_draft.edit.title": "Dileu newidiadau i'ch postiad?",
  "confirmations.discard_draft.post.cancel": "Ail-ddechrau'r drafft",
  "confirmations.discard_draft.post.message": "Bydd parhau yn dileu'r postiad rydych chi'n ei ysgrifennu ar hyn o bryd.",
  "confirmations.discard_draft.post.title": "Dileu drafft eich postiad?",
  "confirmations.discard_edit_media.confirm": "Dileu",
  "confirmations.discard_edit_media.message": "Mae gennych newidiadau heb eu cadw i'r disgrifiad cyfryngau neu'r rhagolwg - eu dileu beth bynnag?",
  "confirmations.follow_to_list.confirm": "Dilyn ac ychwanegu at y rhestr",
  "confirmations.follow_to_list.message": "Mae angen i chi fod yn dilyn {name} i'w ychwanegu at restr.",
  "confirmations.follow_to_list.title": "Dilyn defnyddiwr?",
  "confirmations.hide_featured_tab.confirm": "Cuddio'r tab",
  "confirmations.hide_featured_tab.intro": "Gallwch newid hyn unrhyw bryd o dan <i>Golygu proffil > gosodiadau'r tab Proffil</i> .",
  "confirmations.hide_featured_tab.message": "Bydd hyn yn cuddio'r tab ar gyfer defnyddwyr ar {serverName} a gweinyddion eraill sy'n rhedeg y fersiwn ddiweddaraf o Mastodon. Gall dangosiadau eraill amrywio.",
  "confirmations.hide_featured_tab.title": "Cuddio'r tab \"Nodwedd\"?",
  "confirmations.logout.confirm": "Allgofnodi",
  "confirmations.logout.message": "Ydych chi'n siŵr eich bod am allgofnodi?",
  "confirmations.logout.title": "Allgofnodi?",
  "confirmations.missing_alt_text.confirm": "Ychwanegu testun amgen",
  "confirmations.missing_alt_text.message": "Mae eich postiad yn cynnwys cyfryngau heb destun amgen. Mae ychwanegu disgrifiadau yn helpu i wneud eich cynnwys yn hygyrch i fwy o bobl.",
  "confirmations.missing_alt_text.secondary": "Postio beth bynnag",
  "confirmations.missing_alt_text.title": "Ychwanegu testun amgen?",
  "confirmations.mute.confirm": "Tewi",
  "confirmations.private_quote_notify.cancel": "Nôl i olygu",
  "confirmations.private_quote_notify.confirm": "Cyhoeddi postiad",
  "confirmations.private_quote_notify.do_not_show_again": "Peidio dangos y neges hon i mi eto",
  "confirmations.private_quote_notify.message": "Bydd y person rydych chi'n ei ddyfynnu a chrybwylliadau eraill yn cael gwybod a bydd yn gallu gweld eich postiad, hyd yn oed os nad ydyn nhw'n eich dilyn chi.",
  "confirmations.private_quote_notify.title": "Rhannu gyda dilynwyr a defnyddwyr sy'n cael eu crybwyll?",
  "confirmations.quiet_post_quote_info.dismiss": "Peidio fy atgoff eto",
  "confirmations.quiet_post_quote_info.got_it": "Iawn",
  "confirmations.quiet_post_quote_info.message": "Wrth ddyfynnu postiad cyhoeddus tawel, bydd eich postiad yn cael ei guddio rhag llinellau amser sy'n trendio.",
  "confirmations.quiet_post_quote_info.title": "Yn dyfynnu postiadau cyhoeddus tawel",
  "confirmations.redraft.confirm": "Dileu ac ailddrafftio",
  "confirmations.redraft.message": "Ydych chi wir eisiau'r dileu'r postiad hwn a'i ail lunio? Bydd ffefrynnau a hybiau'n cael eu colli, a bydd atebion i'r postiad gwreiddiol yn mynd yn amddifad.",
  "confirmations.redraft.title": "Dileu ac ail lunio'r postiad?",
  "confirmations.remove_from_followers.confirm": "Dileu dilynwr",
  "confirmations.remove_from_followers.message": "Bydd {name} yn rhoi'r gorau i'ch dilyn. A ydych yn siŵr eich bod am fwrw ymlaen?",
  "confirmations.remove_from_followers.title": "Tynnu dilynwr?",
  "confirmations.revoke_collection_inclusion.confirm": "Tynnu fi",
  "confirmations.revoke_collection_inclusion.message": "Mae'r weithred hon yn barhaol, a fydd y curadur ddim yn gallu eich ail-ychwanegu at y casgliad yn ddiweddarach.",
  "confirmations.revoke_collection_inclusion.title": "Tynnu eich hun o'r casgliad hwn?",
  "confirmations.revoke_quote.confirm": "Dileu'r postiad",
  "confirmations.revoke_quote.message": "Does dim modd dadwneud y weithred hon.",
  "confirmations.revoke_quote.title": "Dileu'r postiad?",
  "confirmations.unblock.confirm": "Dadrwystro",
  "confirmations.unblock.title": "Dadrwystro {name}?",
  "confirmations.unfollow.confirm": "Dad-ddilyn",
  "confirmations.unfollow.title": "Dad-ddilyn {name}",
  "confirmations.withdraw_request.confirm": "Tynnu'r cais yn ôl",
  "confirmations.withdraw_request.title": "Tynnu nôl y cais i ddilyn {name}?",
  "content_warning.hide": "Cuddio'r postiad",
  "content_warning.show": "Dangos beth bynnag",
  "content_warning.show_more": "Dangos rhagor",
  "content_warning.show_short": "Dangos",
  "conversation.delete": "Dileu sgwrs",
  "conversation.mark_as_read": "Nodi fel wedi'i ddarllen",
  "conversation.open": "Gweld sgwrs",
  "conversation.with": "Gyda {names}",
  "copy_icon_button.copied": "Copïwyd i'r clipfwrdd",
  "copy_icon_button.copy_this_text": "Copïo dolen i'r clipfwrdd",
  "copypaste.copied": "Wedi ei gopïo",
  "copypaste.copy_to_clipboard": "Copïo i'r clipfwrdd",
  "directory.federated": "O'r ffedysawd cyfan",
  "directory.local": "O {domain} yn unig",
  "directory.new_arrivals": "Defnyddwyr newydd",
  "directory.recently_active": "Ar-lein yn ddiweddar",
  "disabled_account_banner.account_settings": "Gosodiadau'r cyfrif",
  "disabled_account_banner.text": "Mae eich cyfrif {disabledAccount} wedi ei analluogi ar hyn o bryd.",
  "dismissable_banner.community_timeline": "Dyma'r postiadau cyhoeddus diweddaraf gan bobl sydd a'u cyfrifon ar {domain}.",
  "dismissable_banner.dismiss": "Diystyru",
  "dismissable_banner.public_timeline": "Dyma'r postiadau cyhoeddus diweddaraf gan bobl ar y ffedysawd y mae pobl ar {domain} yn eu dilyn.",
  "domain_block_modal.block": "Blocio gweinydd",
  "domain_block_modal.block_account_instead": "Rhwystro @{name} yn lle hynny",
  "domain_block_modal.they_can_interact_with_old_posts": "Gall pobl o'r gweinydd hwn ryngweithio â'ch hen bostiadau.",
  "domain_block_modal.they_cant_follow": "All neb o'r gweinydd hwn eich dilyn.",
  "domain_block_modal.they_wont_know": "Fyddan nhw ddim yn gwybod eu bod wedi cael eu blocio.",
  "domain_block_modal.title": "Blocio parth?",
  "domain_block_modal.you_will_lose_num_followers": "Byddwch yn colli {followersCount, plural, one {{followersCountDisplay} dilynwr} other {{followersCountDisplay} dilynwr}} a {followingCount, plural, one {{followingCountDisplay} person rydych yn dilyn} other {{followingCountDisplay} o bobl rydych yn eu dilyn}}.",
  "domain_block_modal.you_will_lose_relationships": "Byddwch yn colli'r holl ddilynwyr a phobl rydych chi'n eu dilyn o'r gweinydd hwn.",
  "domain_block_modal.you_wont_see_posts": "Fyddwch chi ddim yn gweld postiadau na hysbysiadau gan ddefnyddwyr ar y gweinydd hwn.",
  "domain_pill.activitypub_lets_connect": "Mae'n caniatáu ichi gysylltu a rhyngweithio â phobl nid yn unig ar Mastodon, ond ar draws gwahanol apiau cymdeithasol hefyd.",
  "domain_pill.activitypub_like_language": "Mae ActivityPub fel yr iaith y mae Mastodon yn ei siarad â rhwydweithiau cymdeithasol eraill.",
  "domain_pill.server": "Gweinydd",
  "domain_pill.their_handle": "Eu handlen:",
  "domain_pill.their_server": "Eu cartref digidol, lle mae eu holl negeseuon yn byw.",
  "domain_pill.their_username": "Eu dynodwr unigryw ar eu gweinydd. Mae'n bosibl dod o hyd i ddefnyddwyr gyda'r un enw defnyddiwr ar wahanol weinyddion.",
  "domain_pill.username": "Enw Defnyddiwr",
  "domain_pill.whats_in_a_handle": "Beth sydd mewn handlen?",
  "domain_pill.who_they_are": "Gan fod handlen yn dweud pwy yw rhywun a ble maen nhw, gallwch chi ryngweithio â phobl ar draws gwe gymdeithasol <button>llwyfannau wedi'u pweru gan ActivityPub</button>.",
  "domain_pill.who_you_are": "Oherwydd bod eich handlen yn dweud pwy ydych chi a ble rydych chi, gall pobl ryngweithio â chi ar draws gwe gymdeithasol <button>llwyfannau wedi'u pweru gan ActivityPub</button>.",
  "domain_pill.your_handle": "Eich handlen:",
  "domain_pill.your_server": "Eich cartref digidol, lle mae'ch holl bostiadau'n byw. Ddim yn hoffi'r un hon? Trosglwyddwch weinyddion ar unrhyw adeg a dewch â'ch dilynwyr hefyd.",
  "domain_pill.your_username": "Eich dynodwr unigryw ar y gweinydd hwn. Mae'n bosibl dod o hyd i ddefnyddwyr gyda'r un enw defnyddiwr ar wahanol weinyddion.",
  "dropdown.empty": "Dewis dewis",
  "email_subscriptions.email": "E-bost",
  "email_subscriptions.form.action": "Tanysgrifio",
  "email_subscriptions.form.bottom": "Derbyniwch bostiadau yn eich blwch derbyn heb greu cyfrif Mastodon. Dad-danysgrifiwch unrhyw bryd. Am ragor o wybodaeth, cyfeiriwch at y <a>Polisi Preifatrwydd</a> .",
  "email_subscriptions.form.title": "Cofrestrwch am ddiweddariadau e-bost gan {name}",
  "email_subscriptions.submitted.lead": "Gwiriwch eich blwch derbyn am e-bost i orffen cofrestru ar gyfer diweddariadau e-bost.",
  "email_subscriptions.submitted.title": "Un cam arall",
  "email_subscriptions.validation.email.blocked": "Darparwr e-bost wedi'i rwystro",
  "email_subscriptions.validation.email.invalid": "Cyfeiriad e-bost annilys",
  "embed.instructions": "Gosodwch y post hwn ar eich gwefan drwy gopïo'r côd isod.",
  "embed.preview": "Dyma sut olwg fydd arno:",
  "emoji_button.activity": "Gweithgarwch",
  "emoji_button.clear": "Clirio",
  "emoji_button.custom": "Cyfaddas",
  "emoji_button.flags": "Baneri",
  "emoji_button.food": "Bwyd & Diod",
  "emoji_button.label": "Mewnosod emoji",
  "emoji_button.nature": "Natur",
  "emoji_button.not_found": "Dim emojiau'n cydweddu i'w cael",
  "emoji_button.objects": "Gwrthrychau",
  "emoji_button.people": "Pobl",
  "emoji_button.recent": "Defnydd cyffredin",
  "emoji_button.search": "Chwilio...",
  "emoji_button.search_results": "Canlyniadau chwilio",
  "emoji_button.symbols": "Symbolau",
  "emoji_button.travel": "Teithio a Llefydd",
  "empty_column.account_featured.other": "Nid yw {acct} wedi cynnwys unrhyw beth eto.",
  "empty_column.account_featured_self.no_collections_button": "Creu casgliad",
  "empty_column.account_featured_self.no_collections_hide_tab": "Cuddio'r tab hwn yn lle hynny",
  "empty_column.account_featured_self.pre_collections": "Cadwch lygad allan am Gasgliadau",
  "empty_column.account_featured_self.pre_collections_desc": "Mae Casgliadau (sy'n dod yn Mastodon 4.6) yn caniatáu ichi greu eich rhestrau cyfrifon wedi'u curadu eich hun i'w hargymell i eraill.",
  "empty_column.account_featured_self.showcase_accounts": "Dangoswch eich hoff gyfrifon",
  "empty_column.account_featured_self.showcase_accounts_desc": "Rhestrau wedi'u curadu o gyfrifon yw Casgliadau i helpu eraill i ddarganfod mwy o'r Fediverse.",
  "empty_column.account_featured_unknown.other": "Dyw'r cyfrif hwn ddim wedi cynnwys unrhyw beth eto.",
  "empty_column.account_hides_collections": "Mae'r defnyddiwr wedi dewis i beidio rhannu'r wybodaeth yma",
  "empty_column.account_suspended": "Cyfrif wedi'i atal",
  "empty_column.account_timeline": "Dim postiadau yma!",
  "empty_column.account_unavailable": "Dyw'r proffil ddim ar gael",
  "empty_column.blocks": "Dydych chi heb rwystro unrhyw ddefnyddwyr eto.",
  "empty_column.bookmarked_statuses": "Does gennych chi ddim unrhyw bostiad wedi'u cadw fel nod tudalen eto. Pan fyddwch yn gosod nod tudalen i un, mi fydd yn ymddangos yma.",
  "empty_column.collections.featured_in": "Dydych chi heb gael eich ychwanegu at unrhyw gasgliadau eto.",
  "empty_column.community": "Mae'r ffrwd lleol yn wag. Beth am ysgrifennu rhywbeth cyhoeddus!",
  "empty_column.direct": "Does gennych chi unrhyw grybwylliadau preifat eto. Pan fyddwch chi'n anfon neu'n derbyn un, bydd yn ymddangos yma.",
  "empty_column.disabled_feed": "Mae'r ffrwd hon wedi'i hanalluogi gan weinyddwyr eich gweinydd.",
  "empty_column.domain_blocks": "Does dim parthau wedi'u rhwystro eto.",
  "empty_column.explore_statuses": "Does dim pynciau llosg ar hyn o bryd. Dewch nôl nes ymlaen!",
  "empty_column.favourited_statuses": "Rydych chi heb ffafrio unrhyw bostiadau eto. Pan byddwch chi'n ffafrio un, bydd yn ymddangos yma.",
  "empty_column.favourites": "Does neb wedi ffafrio'r postiad hwn eto. Pan fydd rhywun yn gwneud hynny, byddan nhw'n ymddangos yma.",
  "empty_column.follow_requests": "Does gennych chi ddim ceisiadau dilyn eto. Pan fyddwch yn derbyn un, byddan nhw'n ymddangos yma.",
  "empty_column.followed_tags": "Dydych chi heb ddilyn unrhyw hashnodau eto. Pan fyddwch chi'n gwneud hynny, byddan nhw'n ymddangos yma.",
  "empty_column.hashtag": "Does dim ar yr hashnod hwn eto.",
  "empty_column.home": "Mae eich ffrwd gartref yn wag! Dilynwch ragor o bobl i'w llenwi.",
  "empty_column.list": "Does dim yn y rhestr yma eto. Pan fydd aelodau'r rhestr yn cyhoeddi postiad newydd, mi fydd yn ymddangos yma.",
  "empty_column.mutes": "Dydych chi heb dewi unrhyw ddefnyddwyr eto.",
  "empty_column.notification_requests": "Dim i boeni amdano! Does dim byd yma. Pan fyddwch yn derbyn hysbysiadau newydd, byddan nhw'n ymddangos yma yn ôl eich gosodiadau.",
  "empty_column.notifications": "Does gennych chi ddim hysbysiadau eto. Pan fyddwch chi'n rhyngweithio ag eraill, byddwch yn ei weld yma.",
  "empty_column.public": "Does dim byd yma! Ysgrifennwch rywbeth cyhoeddus, neu dilynwch ddefnyddwyr o weinyddion eraill i'w lanw",
  "empty_state.no_results": "Dim canlyniadau",
  "error.no_hashtag_feed_access": "Ymunwch neu mewngofnodwch i weld a dilyn yr hashnod hwn.",
  "error.unexpected_crash.explanation": "Oherwydd gwall yn ein cod neu oherwydd problem cysondeb porwr, nid oedd y dudalen hon gallu cael ei dangos yn gywir.",
  "error.unexpected_crash.explanation_addons": "Does dim modd dangos y dudalen hon yn gywir. Mae'r gwall hwn yn debygol o gael ei achosi gan ategyn porwr neu offer cyfieithu awtomatig.",
  "error.unexpected_crash.next_steps": "Ceisiwch ail-lwytho'r dudalen. Os nad yw hyn yn eich helpu, efallai gallwch ddefnyddio Mastodon trwy borwr neu ap brodorol gwahanol.",
  "error.unexpected_crash.next_steps_addons": "Ceisiwch eu hanalluogi ac adnewyddu'r dudalen. Os nad yw hynny'n helpu, efallai y byddwch yn dal i allu defnyddio Mastodon trwy borwr neu ap cynhenid arall.",
  "errors.unexpected_crash.copy_stacktrace": "Copïo'r olrhain stac i'r clipfwrdd",
  "errors.unexpected_crash.report_issue": "Rhoi gwybod am broblem",
  "explore.suggested_follows": "Pobl",
  "explore.title": "Yn Trendio",
  "explore.trending_links": "Newyddion",
  "explore.trending_statuses": "Postiadau",
  "explore.trending_tags": "Hashnodau",
  "featured_carousel.current": "<sr>Postiad</sr> {current, number} / {max, number}",
  "featured_carousel.header": "{count, plural, one {Postiad wedi'i binio} other {Postiadau wedi'u pinio}}",
  "featured_carousel.slide": "Postiad {current, number} of {max, number}",
  "featured_tags.more_items": "+{count}",
  "featured_tags.suggestions": "Yn ddiweddar rydych chi wedi postio am {items}. Ychwanegu'r rhain fel hashnodau dan sylw?",
  "featured_tags.suggestions.add": "Ychwanegu",
  "featured_tags.suggestions.added": "Rheoli eich hashnodau dan sylw ar unrhyw adeg o dan<link> Golygu Proffil > Hashnodau dan sylw</link> .",
  "featured_tags.suggestions.dismiss": "Dim diolch",
  "filter_modal.added.context_mismatch_explanation": "Dyw'r categori hidlo hwn ddim yn berthnasol i'r cyd-destun yr ydych wedi cyrchu'r postiad hwn ynddo. Os ydych chi am i'r postiad gael ei hidlo yn y cyd-destun hwn hefyd, bydd yn rhaid i chi olygu'r hidlydd.",
  "filter_modal.added.context_mismatch_title": "Diffyg cyfatebiaeth cyd-destun!",
  "filter_modal.added.expired_explanation": "Mae'r categori hidlydd hwn wedi dod i ben, bydd angen i chi newid y dyddiad dod i ben er mwyn iddo fod yn berthnasol.",
  "filter_modal.added.expired_title": "Hidlydd wedi dod i ben!",
  "filter_modal.added.review_and_configure": "I adolygu a ffurfweddu'r categori hidlydd hwn ymhellach, ewch i'r {settings_link}.",
  "filter_modal.added.review_and_configure_title": "Gosodiadau hidlo",
  "filter_modal.added.settings_link": "tudalen gosodiadau",
  "filter_modal.added.short_explanation": "Mae'r postiad hwn wedi'i ychwanegu at y categori hidlo canlynol: {title}.",
  "filter_modal.added.title": "Hidlydd wedi'i ychwanegu!",
  "filter_modal.select_filter.context_mismatch": "nid yw'n berthnasol i'r cyd-destun hwn",
  "filter_modal.select_filter.expired": "daeth i ben",
  "filter_modal.select_filter.prompt_new": "Categori newydd: {name}",
  "filter_modal.select_filter.search": "Chwilio neu greu",
  "filter_modal.select_filter.subtitle": "Defnyddiwch gategori sy'n bodoli eisoes neu crëu un newydd",
  "filter_modal.select_filter.title": "Hidlo'r postiad hwn",
  "filter_modal.title.status": "Hidlo postiad",
  "filter_warning.matches_filter": "Yn cyd-fynd â'r hidlydd “ <span>{title}</span> ”",
  "filtered_notifications_banner.pending_requests": "Oddi wrth {count, plural, =0 {no one} one {un person} two {# berson} few {# pherson} other {# person}} efallai eich bod yn eu hadnabod",
  "filtered_notifications_banner.title": "Hysbysiadau wedi'u hidlo",
  "firehose.all": "Popeth",
  "firehose.local": "Y gweinydd hwn",
  "firehose.remote": "Gweinyddion eraill",
  "follow_request.authorize": "Awdurdodi",
  "follow_request.reject": "Gwrthod",
  "follow_requests.unlocked_explanation": "Er nad yw eich cyfrif wedi'i gloi, roedd y staff {domain} yn meddwl efallai hoffech adolygu ceisiadau dilyn o'r cyfrifau rhain wrth law.",
  "follow_suggestions.curated_suggestion": "Dewis staff",
  "follow_suggestions.dismiss": "Peidio â dangos hwn eto",
  "follow_suggestions.featured_longer": "Wedi'i ddewis â llaw gan dîm {domain}",
  "follow_suggestions.friends_of_friends_longer": "Yn boblogaidd ymhlith y bobl rydych chi'n eu dilyn",
  "follow_suggestions.hints.featured": "Mae'r proffil hwn wedi'i ddewis yn arbennig gan dîm {domain}.",
  "follow_suggestions.hints.friends_of_friends": "Mae'r proffil hwn yn boblogaidd ymhlith y bobl rydych chi'n eu dilyn.",
  "follow_suggestions.hints.most_followed": "Mae'r proffil hwn yn un o'r rhai sy'n cael ei ddilyn fwyaf ar {domain}.",
  "follow_suggestions.hints.most_interactions": "Mae'r proffil hwn wedi bod yn cael llawer o sylw yn ddiweddar ar {domain}.",
  "follow_suggestions.hints.similar_to_recently_followed": "Mae'r proffil hwn yn debyg i'r proffiliau rydych chi wedi'u dilyn yn fwyaf diweddar.",
  "follow_suggestions.personalized_suggestion": "Awgrym personol",
  "follow_suggestions.popular_suggestion": "Awgrym poblogaidd",
  "follow_suggestions.popular_suggestion_longer": "Yn boblogaidd ar {domain}",
  "follow_suggestions.similar_to_recently_followed_longer": "Yn debyg i broffiliau rydych wedi'u dilyn yn ddiweddar",
  "follow_suggestions.view_all": "Gweld y cyfan",
  "follow_suggestions.who_to_follow": "Pwy i ddilyn",
  "followed_tags": "Hashnodau rydych yn eu dilyn",
  "followers.hide_other_followers": "Mae'r defnyddiwr hwn wedi dewis peidio â gwneud ei ddilynwyr eraill yn weladwy",
  "followers.title": "Yn dilyn {name}",
  "following.hide_other_following": "Mae'r defnyddiwr hwn wedi dewis peidio â gwneud gweddill y rhai maen nhw'n eu dilyn yn weladwy",
  "following.title": "Wedi'i ddilyn gan {name}",
  "footer.about": "Ynghylch",
  "footer.about_mastodon": "Ynglŷn â Mastodon",
  "footer.about_server": "Ynglŷn â {domain}",
  "footer.about_this_server": "Ynghylch",
  "footer.directory": "Cyfeiriadur proffiliau",
  "footer.get_app": "Llwytho'r ap i lawr",
  "footer.keyboard_shortcuts": "Bysellau brys",
  "footer.privacy_policy": "Polisi preifatrwydd",
  "footer.source_code": "Gweld y cod ffynhonnell",
  "footer.status": "Statws",
  "footer.terms_of_service": "Telerau gwasanaeth",
  "form_error.blank": "Gall y maes ddim fod yn wag.",
  "form_field.optional": "(dewisol)",
  "generic.saved": "Wedi'i Gadw",
  "getting_started.heading": "Dechrau arni",
  "hashtag.admin_moderation": "Agor rhyngwyneb cymedroli #{name}",
  "hashtag.browse": "Pori postiadau yn #{hashtag}",
  "hashtag.browse_from_account": "Pori postiadau gan @{name} yn #{hashtag}",
  "hashtag.column_header.tag_mode.all": "a {additional}",
  "hashtag.column_header.tag_mode.any": "neu {additional}",
  "hashtag.column_header.tag_mode.none": "heb {additional}",
  "hashtag.column_settings.select.no_options_message": "Dim awgrymiadau i'w gweld",
  "hashtag.column_settings.select.placeholder": "Mewnbynnu hashnodau…",
  "hashtag.column_settings.tag_mode.all": "Pob un o'r rhain",
  "hashtag.column_settings.tag_mode.any": "Unrhyw un o'r rhain",
  "hashtag.column_settings.tag_mode.none": "Dim o'r rhain",
  "hashtag.column_settings.tag_toggle": "Cynnwys tagiau ychwanegol ar gyfer y golofn hon",
  "hashtag.counter_by_accounts": "{count, plural, one {{counter} cyfranogwr} other {{counter} cyfranogwr}}",
  "hashtag.counter_by_uses": "{count, plural, one {postiad {counter}} other {postiad {counter}}}",
  "hashtag.counter_by_uses_today": "{count, plural, one {{counter} postiad} other {{counter} postiad}} heddiw",
  "hashtag.feature": "Nodwedd ar y proffil",
  "hashtag.follow": "Dilyn hashnod",
  "hashtag.mute": "Tewi #{hashtag}",
  "hashtag.unfeature": "Peidio a'i gynnwys ar y proffil",
  "hashtag.unfollow": "Dad-ddilyn hashnod",
  "hashtags.and_other": "…a {count, plural, other {# arall}}",
  "hints.profiles.followers_may_be_missing": "Mae'n bosibl bod dilynwyr y proffil hwn ar goll.",
  "hints.profiles.follows_may_be_missing": "Mae'n bosibl bod dilynwyr y proffil hwn ar goll.",
  "hints.profiles.posts_may_be_missing": "Mae'n bosibl bod rhai postiadau y proffil hwn ar goll.",
  "hints.profiles.see_more_followers": "Gweld mwy o ddilynwyr ar {domain}",
  "hints.profiles.see_more_follows": "Gweld mwy o 'yn dilyn' ar {domain}",
  "hints.profiles.see_more_posts": "Gweld mwy o bostiadau ar {domain}",
  "home.column_settings.show_quotes": "Dangos dyfyniadau",
  "home.column_settings.show_reblogs": "Dangos hybiau",
  "home.column_settings.show_replies": "Dangos ymatebion",
  "home.hide_announcements": "Cuddio cyhoeddiadau",
  "home.pending_critical_update.body": "Diweddarwch eich gweinydd Mastodon cyn gynted â phosibl!",
  "home.pending_critical_update.link": "Gweld diweddariadau",
  "home.pending_critical_update.title": "Mae diweddariad diogelwch hanfodol ar gael!",
  "home.show_announcements": "Dangos cyhoeddiadau",
  "ignore_notifications_modal.disclaimer": "Dyw Mastodon ddim yn gallu hysbysu defnyddwyr eich bod wedi anwybyddu eu hysbysiadau. Bydd anwybyddu hysbysiadau ddim yn atal y negeseuon eu hunain rhag cael eu hanfon.",
  "ignore_notifications_modal.filter_instead": "Hidlo yn lle hynny",
  "ignore_notifications_modal.filter_to_act_users": "Byddwch yn dal i allu derbyn, gwrthod neu adrodd ar ddefnyddwyr",
  "ignore_notifications_modal.filter_to_avoid_confusion": "Mae hidlo yn helpu i osgoi dryswch posibl",
  "ignore_notifications_modal.filter_to_review_separately": "Gallwch adolygu hysbysiadau wedi'u hidlo ar wahân",
  "ignore_notifications_modal.ignore": "Anwybyddu hysbysiadau",
  "ignore_notifications_modal.limited_accounts_title": "Anwybyddu hysbysiadau o gyfrifon wedi'u cymedroli?",
  "ignore_notifications_modal.new_accounts_title": "Anwybyddu hysbysiadau o gyfrifon newydd?",
  "ignore_notifications_modal.not_followers_title": "Anwybyddu hysbysiadau gan bobl nad ydynt yn eich dilyn?",
  "ignore_notifications_modal.not_following_title": "Anwybyddu hysbysiadau gan bobl nad ydych yn eu dilyn?",
  "ignore_notifications_modal.private_mentions_title": "Anwybyddu hysbysiadau o Grybwylliadau Preifat digymell?",
  "info_button.label": "Cymorth",
  "info_button.what_is_alt_text": "<h1>Beth yw testun amgen?</h1><p> Mae Testun Amgen yn darparu disgrifiadau delwedd ar gyfer pobl â nam ar eu golwg, cysylltiadau lled band isel, neu'r rhai sy'n ceisio cyd-destun ychwanegol.</p><p> Gallwch wella hygyrchedd a dealltwriaeth i bawb trwy ysgrifennu testun amgen clir, cryno a gwrthrychol.</p><ul><li> Dal elfennau pwysig</li><li> Crynhoi testun mewn delweddau</li><li> Defnyddiwch strwythur brawddegau rheolaidd</li><li> Osgoi gwybodaeth ddiangen</li><li> Canolbwyntio ar dueddiadau a chanfyddiadau allweddol mewn delweddau cymhleth (fel diagramau neu fapiau)</li></ul>",
  "interaction_modal.action": "I ryngweithio â phostiad {name}, mae angen i chi fewngofnodi i'ch cyfrif ar ba bynnag weinydd Mastodon rydych chi'n ei ddefnyddio.",
  "interaction_modal.go": "Mynd",
  "interaction_modal.no_account_yet": "Dim cyfrif eto?",
  "interaction_modal.on_another_server": "Ar weinydd gwahanol",
  "interaction_modal.on_this_server": "Ar y gweinydd hwn",
  "interaction_modal.title": "Mewngofnodwch i barhau",
  "interaction_modal.username_prompt": "e.e. {example}",
  "intervals.full.days": "{number, plural, one {# diwrnod} two {# ddiwrnod} other {# diwrnod}}",
  "intervals.full.hours": "{number, plural, one {# awr} other {# awr}}",
  "intervals.full.minutes": "{number, plural, one {# funud} other {# munud}}",
  "keyboard_shortcuts.back": "Symud nôl",
  "keyboard_shortcuts.blocked": "Agor rhestr defnyddwyr sydd wedi'i rwystro",
  "keyboard_shortcuts.boost": "Hybu postiad",
  "keyboard_shortcuts.column": "Ffocysu colofn",
  "keyboard_shortcuts.compose": "Ffocysu ar ardal cyfansoddi testun",
  "keyboard_shortcuts.description": "Disgrifiad",
  "keyboard_shortcuts.direct": "Agor colofn sylwadau preifat",
  "keyboard_shortcuts.down": "Symud lawr yn y rhestr",
  "keyboard_shortcuts.enter": "Agor post",
  "keyboard_shortcuts.explore": "Agor llinell amser trendio",
  "keyboard_shortcuts.favourite": "Ffafrio postiad",
  "keyboard_shortcuts.favourites": "Agor rhestr ffefrynnau",
  "keyboard_shortcuts.federated": "Agor ffrwd y ffederasiwn",
  "keyboard_shortcuts.heading": "Bysellau brys",
  "keyboard_shortcuts.home": "Agor ffrwd gartref",
  "keyboard_shortcuts.hotkey": "Bysell boeth",
  "keyboard_shortcuts.legend": "Dangos yr allwedd hon",
  "keyboard_shortcuts.load_more": "Canolbwyntio ar y botwm \"Llwytho rhagor\"",
  "keyboard_shortcuts.local": "Agor ffrwd lleol",
  "keyboard_shortcuts.mention": "Crybwyll yr awdur",
  "keyboard_shortcuts.muted": "Agor rhestr defnyddwyr rydych wedi'u tewi",
  "keyboard_shortcuts.my_profile": "Agor eich proffil",
  "keyboard_shortcuts.notifications": "Agor colofn hysbysiadau",
  "keyboard_shortcuts.open_media": "Agor cyfryngau",
  "keyboard_shortcuts.pinned": "Agor rhestr postiadau wedi'u pinio",
  "keyboard_shortcuts.profile": "Agor proffil yr awdur",
  "keyboard_shortcuts.quote": "Dyfynnu postiad",
  "keyboard_shortcuts.reply": "Ateb postiad",
  "keyboard_shortcuts.requests": "Agor rhestr ceisiadau dilyn",
  "keyboard_shortcuts.search": "Ffocysu ar y bar chwilio",
  "keyboard_shortcuts.spoilers": "Dangos/cuddio'r maes CW",
  "keyboard_shortcuts.start": "Agor colofn \"dechrau arni\"",
  "keyboard_shortcuts.toggle_hidden": "Dangos/cuddio testun tu ôl i CW",
  "keyboard_shortcuts.toggle_sensitivity": "Dangos/cuddio cyfryngau",
  "keyboard_shortcuts.toot": "Dechrau post newydd",
  "keyboard_shortcuts.top": "Symud i frig y rhestr",
  "keyboard_shortcuts.translate": "i gyfieithu postiad",
  "keyboard_shortcuts.unfocus": "Dad-ffocysu ardal cyfansoddi testun/chwilio",
  "keyboard_shortcuts.up": "Symud yn uwch yn y rhestr",
  "learn_more_link.got_it": "Iawn",
  "learn_more_link.learn_more": "Dysgu rhagor",
  "lightbox.close": "Cau",
  "lightbox.next": "Nesaf",
  "lightbox.previous": "Blaenorol",
  "lightbox.zoom_in": "Chwyddo i faint gwirioneddol",
  "lightbox.zoom_out": "Chwyddo i ffitio",
  "limited_account_hint.action": "Dangos y proffil beth bynnag",
  "limited_account_hint.title": "Mae'r proffil hwn wedi cael ei guddio gan gymedrolwyr {domain}.",
  "link_preview.author": "Gan {name}",
  "link_preview.more_from_author": "Mwy gan {name}",
  "link_preview.shares": "{count, plural, one {{counter} postiad } two {{counter} bostiad } few {{counter} postiad} many {{counter} postiad} other {{counter} postiad}}",
  "lists.add_member": "Ychwanegu",
  "lists.add_to_list": "Ychwanegu at restr",
  "lists.add_to_lists": "Ychwanegu {name} at restrau",
  "lists.create": "Creu",
  "lists.create_a_list_to_organize": "Creu rhestr newydd i drefnu eich llif Cartref",
  "lists.create_list": "Creu rhestr",
  "lists.delete": "Dileu'r rhestr",
  "lists.done": "Wedi gorffen",
  "lists.edit": "Golygu'r rhestr",
  "lists.exclusive": "Cuddio aelodau yn y Cartref",
  "lists.exclusive_hint": "Os oes rhywun ar y rhestr hon, cuddiwch nhw yn eich llif Cartref i osgoi gweld eu postiadau ddwywaith.",
  "lists.find_users_to_add": "Canfod defnyddwyr i'w hychwanegu",
  "lists.list_members_count": "{count, plural, one {# aelod} other {# aelod}}",
  "lists.list_name": "Enw rhestr",
  "lists.new_list_name": "Enw rhestr newydd",
  "lists.no_lists_yet": "Dim rhestrau eto.",
  "lists.no_members_yet": "Dim aelodau eto.",
  "lists.no_results_found": "Heb ganfod canlyniadau.",
  "lists.remove_member": "Tynnu",
  "lists.replies_policy.followed": "Unrhyw ddefnyddiwr sy'n cael ei ddilyn",
  "lists.replies_policy.list": "Aelodau'r rhestr",
  "lists.replies_policy.none": "Neb",
  "lists.save": "Cadw",
  "lists.search": "Chwilio",
  "lists.show_replies_to": "Cynnwys ymatebion gan aelodau'r rhestr i",
  "load_pending": "{count, plural, one {# eitem newydd} other {# eitem newydd}}",
  "loading_indicator.label": "Yn llwytho…",
  "media_gallery.hide": "Cuddio",
  "moved_to_account_banner.text": "Mae eich cyfrif {disabledAccount} wedi ei analluogi ar hyn o bryd am i chi symud i {movedToAccount}.",
  "mute_modal.hide_from_notifications": "Cuddio rhag hysbysiadau",
  "mute_modal.hide_options": "Cuddio'r dewis",
  "mute_modal.indefinite": "Nes i mi eu dad-dewi",
  "mute_modal.show_options": "Dangos y dewis",
  "mute_modal.they_can_mention_and_follow": "Gallan nhw eich crybwyll a'ch dilyn, ond fyddwch chi ddim yn eu gweld.",
  "mute_modal.they_wont_know": "Fyddan nhw ddim yn gwybod eu bod wedi cael eu tawelu.",
  "mute_modal.title": "Tewi defnyddiwr?",
  "mute_modal.you_wont_see_mentions": "Welwch chi ddim postiadau sy'n sôn amdanyn nhw.",
  "mute_modal.you_wont_see_posts": "Gallan nhw weld eich postiadau o hyd, ond fyddwch chi ddim yn gweld eu rhai hwy.",
  "navigation_bar.about": "Ynghylch",
  "navigation_bar.account_settings": "Cyfrinair a diogelwch",
  "navigation_bar.administration": "Gweinyddiaeth",
  "navigation_bar.advanced_interface": "Agor mewn rhyngwyneb gwe uwch",
  "navigation_bar.automated_deletion": "Dileu postiadau'n awtomatig",
  "navigation_bar.blocks": "Defnyddwyr wedi'u rhwystro",
  "navigation_bar.bookmarks": "Nodau Tudalen",
  "navigation_bar.collections": "Casgliadau",
  "navigation_bar.direct": "Crybwylliadau preifat",
  "navigation_bar.domain_blocks": "Parthau wedi'u rhwystro",
  "navigation_bar.favourites": "Ffefrynnau",
  "navigation_bar.filters": "Geiriau wedi'u tewi",
  "navigation_bar.follow_requests": "Ceisiadau dilyn",
  "navigation_bar.followed_tags": "Hashnodau sy'n cael eu dilyn",
  "navigation_bar.follows_and_followers": "Yn dilyn a dilynwyr",
  "navigation_bar.import_export": "Mewnforio ac allforio",
  "navigation_bar.lists": "Rhestrau",
  "navigation_bar.live_feed_local": "Ffrwd fyw (lleol)",
  "navigation_bar.live_feed_public": "Ffrwd fyw (cyhoeddus)",
  "navigation_bar.logout": "Allgofnodi",
  "navigation_bar.moderation": "Cymedroil",
  "navigation_bar.more": "Rhagor",
  "navigation_bar.mutes": "Defnyddwyr wedi'u tewi",
  "navigation_bar.opened_in_classic_interface": "Mae postiadau, cyfrifon a thudalennau penodol eraill yn cael eu hagor fel rhagosodiad yn y rhyngwyneb gwe clasurol.",
  "navigation_bar.preferences": "Dewisiadau",
  "navigation_bar.privacy_and_reach": "Preifatrwydd a chyrhaeddiad",
  "navigation_bar.search": "Chwilio",
  "navigation_bar.search_trends": "Chwilio / Trendio",
  "navigation_panel.collapse_followed_tags": "Cau dewislen hashnodau dilyn",
  "navigation_panel.collapse_lists": "Cau dewislen y rhestr",
  "navigation_panel.expand_followed_tags": "Agor dewislen hashnodau dilyn",
  "navigation_panel.expand_lists": "Ehangu dewislen y rhestr",
  "not_signed_in_indicator.not_signed_in": "Rhaid i chi fewngofnodi i weld yr adnodd hwn.",
  "notification.added_to_collection": "Ychwanegodd {name} chi at gasgliad",
  "notification.admin.report": "Adroddodd {name} {target}",
  "notification.admin.report_account": "Adroddodd {name} {count, plural, one {un postiad} other {# postiad}} gan {target} oherwydd {category}",
  "notification.admin.report_account_other": "Adroddodd {name} {count, plural, one {un postiad} two {# bostiad} few {# postiad} other {# postiad}} gan {target}",
  "notification.admin.report_statuses": "Adroddodd {name} {target} ar gyfer {category}",
  "notification.admin.report_statuses_other": "Adroddodd {name} {target}",
  "notification.admin.sign_up": "Cofrestrodd {name}",
  "notification.admin.sign_up.name_and_others": "Cofrestrodd {name} {count, plural, one {ac # arall} other {a # arall}}",
  "notification.annual_report.message": "Mae eich #Wrapstodon {year} yn aros i chi! Gwelwch eich uchafbwyntiau ac amseroedd i'w cofio o'r flwyddyn hon ar Mastodon!",
  "notification.annual_report.view": "Gweld #Wrapstodon",
  "notification.collection_update": "Golygodd {name} gasgliad rydych chi ynddo",
  "notification.favourite": "Ffafriodd {name} eich postiad",
  "notification.favourite.name_and_others_with_link": "Ffafriodd {name} a <a>{count, plural, one {# arall} other {# arall}}</a> eich postiad",
  "notification.favourite_pm": "Mae {name} wedi ffefrynnu eich cyfeiriad preifat",
  "notification.favourite_pm.name_and_others_with_link": "Mae {name} a <a>{count, plural, one {# arall} other {# arall}}</a> wedi hoffi'ch crybwylliad preifat",
  "notification.follow": "Dilynodd {name} chi",
  "notification.follow.name_and_others": "Mae {name} a <a>{count, plural, zero {}one {# arall} two {# arall} few {# arall} many {# others} other {# arall}}</a> nawr yn eich dilyn chi",
  "notification.follow_request": "Mae {name} wedi gwneud cais i'ch dilyn",
  "notification.follow_request.name_and_others": "Mae {name} a{count, plural, one {# arall} other {# arall}} wedi gofyn i'ch dilyn chi",
  "notification.label.mention": "Crybwyll",
  "notification.label.private_mention": "Crybwyll preifat",
  "notification.label.private_reply": "Ymateb preifat",
  "notification.label.quote": "Mae {name} wedi dyfynnu eich postiad",
  "notification.label.reply": "Ymateb",
  "notification.mention": "Crybwyll",
  "notification.mentioned_you": "Rydych wedi'ch crybwyll gan {name}",
  "notification.moderation-warning.learn_more": "Dysgu mwy",
  "notification.moderation_warning": "Rydych wedi derbyn rhybudd gan gymedrolwr",
  "notification.moderation_warning.action_delete_statuses": "Mae rhai o'ch postiadau wedi'u dileu.",
  "notification.moderation_warning.action_disable": "Mae eich cyfrif wedi'i analluogi.",
  "notification.moderation_warning.action_mark_statuses_as_sensitive": "Mae rhai o'ch postiadau wedi'u marcio'n sensitif.",
  "notification.moderation_warning.action_none": "Mae eich cyfrif wedi derbyn rhybudd cymedroli.",
  "notification.moderation_warning.action_sensitive": "Bydd eich postiadau'n cael eu marcio'n sensitif o hyn ymlaen.",
  "notification.moderation_warning.action_silence": "Mae eich cyfrif wedi'i gyfyngu.",
  "notification.moderation_warning.action_suspend": "Mae eich cyfrif wedi'i atal.",
  "notification.own_poll": "Mae eich pleidlais wedi dod i ben",
  "notification.poll": "Mae arolwg rydych wedi pleidleisio ynddo wedi dod i ben",
  "notification.quoted_update": "Golygodd {name} bostiad rydych chi wedi'i ddyfynnu",
  "notification.reblog": "Hybodd {name} eich post",
  "notification.reblog.name_and_others_with_link": "Mae {name} a <a>{count, plural, one {# arall} other {# arall}}</a> wedi hybu eich postiad",
  "notification.relationships_severance_event": "Wedi colli cysylltiad â {name}",
  "notification.relationships_severance_event.account_suspension": "Mae gweinyddwr o {from} wedi atal {target}, sy'n golygu na allwch dderbyn diweddariadau ganddynt mwyach na rhyngweithio â nhw.",
  "notification.relationships_severance_event.domain_block": "Mae gweinyddwr o {from} wedi blocio {target}, gan gynnwys {followersCount} o'ch dilynwyr a {followingCount, plural, one {# cyfrif} other {# cyfrif}} arall rydych chi'n ei ddilyn.",
  "notification.relationships_severance_event.learn_more": "Dysgu mwy",
  "notification.relationships_severance_event.user_domain_block": "Rydych wedi blocio {target}, gan ddileu {followersCount} o'ch dilynwyr a {followingCount, plural, one {# cyfrif} other {#cyfrifon}} arall rydych yn ei ddilyn.",
  "notification.status": "{name} newydd ei bostio",
  "notification.update": "Golygodd {name} bostiad",
  "notification_requests.accept": "Derbyn",
  "notification_requests.accept_multiple": "{count, plural, one {Derbyn # cais…} other {Derbyn # cais…}}",
  "notification_requests.confirm_accept_multiple.button": "{count, plural, one {Derbyn cais} other {Derbyn cais}}",
  "notification_requests.confirm_accept_multiple.message": "Rydych ar fin derbyn {count, plural, one {un cais hysbysiad} other {# cais hysbysiad}}. Ydych chi'n siŵr eich bod am barhau?",
  "notification_requests.confirm_accept_multiple.title": "Derbyn ceisiadau hysbysu?",
  "notification_requests.confirm_dismiss_multiple.button": "{count, plural, one {Diystyru cais} other {Diystyru ceisiadau}}",
  "notification_requests.confirm_dismiss_multiple.message": "Rydych ar fin diystyru {count, plural, one {un cais hysbysu} other {# cais hysbysiad}}. Fyddwch chi ddim yn gallu cyrchu {count, plural, one {it} other {them}} yn hawdd eto. Ydych chi'n yn siŵr eich bod am fwrw ymlaen?",
  "notification_requests.confirm_dismiss_multiple.title": "Diystyru ceisiadau hysbysu?",
  "notification_requests.dismiss": "Cau",
  "notification_requests.dismiss_multiple": "{count, plural, one {Diystyru # cais…} two {Diystyru # gais…} few {Diystyru # chais…} other {Diystyru # cais…}}",
  "notification_requests.edit_selection": "Golygu",
  "notification_requests.exit_selection": "Iawn",
  "notification_requests.explainer_for_limited_account": "Mae hysbysiadau o'r cyfrif hwn wedi'u hidlo oherwydd bod y cyfrif wedi'i gyfyngu gan gymedrolwr.",
  "notification_requests.explainer_for_limited_remote_account": "Mae hysbysiadau o'r cyfrif hwn wedi'u hidlo oherwydd bod y cyfrif neu ei weinydd wedi'i gyfyngu gan gymedrolwr.",
  "notification_requests.maximize": "Mwyhau",
  "notification_requests.minimize_banner": "Lleihau baner hysbysiadau wedi'u hidlo",
  "notification_requests.notifications_from": "Hysbysiadau gan {name}",
  "notification_requests.title": "Hysbysiadau wedi'u hidlo",
  "notification_requests.view": "Gweld hysbysiadau",
  "notifications.clear": "Clirio hysbysiadau",
  "notifications.clear_confirmation": "Ydych chi'n siŵr eich bod am glirio'ch holl hysbysiadau am byth?",
  "notifications.clear_title": "Clirio hysbysiadau?",
  "notifications.column_settings.admin.report": "Adroddiadau newydd:",
  "notifications.column_settings.admin.sign_up": "Cofrestriadau newydd:",
  "notifications.column_settings.alert": "Hysbysiadau bwrdd gwaith",
  "notifications.column_settings.favourite": "Ffefrynnau:",
  "notifications.column_settings.filter_bar.advanced": "Dangos pob categori",
  "notifications.column_settings.filter_bar.category": "Bar hidlo cyflym",
  "notifications.column_settings.follow": "Dilynwyr newydd:",
  "notifications.column_settings.follow_request": "Ceisiadau dilyn newydd:",
  "notifications.column_settings.group": "Grŵp",
  "notifications.column_settings.mention": "Crybwylliadau:",
  "notifications.column_settings.poll": "Canlyniadau pleidlais:",
  "notifications.column_settings.push": "Hysbysiadau gwthio",
  "notifications.column_settings.quote": "Dyfyniadau:",
  "notifications.column_settings.reblog": "Hybiau:",
  "notifications.column_settings.show": "Dangos yn y golofn",
  "notifications.column_settings.sound": "Chwarae sain",
  "notifications.column_settings.status": "Postiadau newydd:",
  "notifications.column_settings.unread_notifications.category": "Hysbysiadau heb eu darllen",
  "notifications.column_settings.unread_notifications.highlight": "Amlygu hysbysiadau heb eu darllen",
  "notifications.column_settings.update": "Golygiadau:",
  "notifications.filter.all": "Popeth",
  "notifications.filter.boosts": "Hybiau",
  "notifications.filter.favourites": "Ffefrynnau",
  "notifications.filter.follows": "Yn dilyn",
  "notifications.filter.mentions": "Crybwylliadau",
  "notifications.filter.polls": "Canlyniadau pleidleisio",
  "notifications.filter.statuses": "Diweddariadau gan bobl rydych chi'n eu dilyn",
  "notifications.grant_permission": "Caniatáu.",
  "notifications.group": "{count} hysbysiad",
  "notifications.mark_as_read": "Marciwch bob hysbysiad wedi'i ddarllen",
  "notifications.permission_denied": "Does dim hysbysiadau bwrdd gwaith ar gael oherwydd cais am ganiatâd porwr a wrthodwyd yn flaenorol",
  "notifications.permission_denied_alert": "Does dim modd galluogi hysbysiadau bwrdd gwaith, gan fod caniatâd porwr wedi'i wrthod o'r blaen",
  "notifications.permission_required": "Does dim hysbysiadau bwrdd gwaith ar gael oherwydd na roddwyd y caniatâd gofynnol.",
  "notifications.policy.accept": "Derbyn",
  "notifications.policy.accept_hint": "Dangos mewn hysbysiadau",
  "notifications.policy.drop": "Anwybyddu",
  "notifications.policy.drop_hint": "Anfon i'r gwagle, byth i'w gweld eto",
  "notifications.policy.filter": "Hidlo",
  "notifications.policy.filter_hint": "Anfon i flwch derbyn hysbysiadau wedi'u hidlo",
  "notifications.policy.filter_limited_accounts_hint": "Cyfyngwyd gan gymedrolwyr gweinydd",
  "notifications.policy.filter_limited_accounts_title": "Cyfrifon wedi'u cymedroli",
  "notifications.policy.filter_new_accounts.hint": "Crëwyd o fewn {days, plural, one {yr un diwrnod} other {y # diwrnod}} diwethaf",
  "notifications.policy.filter_new_accounts_title": "Cyfrifon newydd",
  "notifications.policy.filter_not_followers_hint": "Gan gynnwys pobl sydd wedi bod yn eich dilyn am llai {days, plural, one {nag un diwrnod} other {na # diwrnod}}",
  "notifications.policy.filter_not_followers_title": "Pobl sydd ddim yn eich dilyn",
  "notifications.policy.filter_not_following_hint": "Hyd nes i chi eu cymeradwyo â llaw",
  "notifications.policy.filter_not_following_title": "Pobl nad ydych yn eu dilyn",
  "notifications.policy.filter_private_mentions_hint": "Wedi'i hidlo oni bai ei fod mewn ymateb i'ch crybwylliad eich hun neu os ydych yn dilyn yr anfonwr",
  "notifications.policy.filter_private_mentions_title": "Crybwylliadau preifat digymell",
  "notifications.policy.title": "Rheoli hysbysiadau gan…",
  "notifications_permission_banner.enable": "Galluogi hysbysiadau bwrdd gwaith",
  "notifications_permission_banner.how_to_control": "I dderbyn hysbysiadau pan nad yw Mastodon ar agor, galluogwch hysbysiadau bwrdd gwaith. Gallwch reoli'n union pa fathau o ryngweithiadau sy'n cynhyrchu hysbysiadau bwrdd gwaith trwy'r botwm {icon} uchod unwaith y byddan nhw wedi'u galluogi.",
  "notifications_permission_banner.title": "Peidiwch â cholli dim",
  "onboarding.follows.back": "Nôl",
  "onboarding.follows.empty": "Yn anffodus, nid oes modd dangos unrhyw ganlyniadau ar hyn o bryd. Gallwch geisio defnyddio chwilio neu bori'r dudalen archwilio i ddod o hyd i bobl i'w dilyn, neu ceisio eto yn nes ymlaen.",
  "onboarding.follows.next": "Nesaf: Gosodwch eich proffil",
  "onboarding.follows.search": "Chwilio",
  "onboarding.follows.title": "Dilynwch bobl i gychwyn arni",
  "onboarding.profile.discoverable": "Gwnewch fy mhroffil yn un y gellir ei ddarganfod",
  "onboarding.profile.discoverable_hint": "Pan fyddwch yn dewis ymuno â darganfod ar Mastodon, gall eich postiadau ymddangos mewn canlyniadau chwilio a threndiau, ac efallai y bydd eich proffil yn cael ei awgrymu i bobl sydd â diddordebau tebyg i chi.",
  "onboarding.profile.display_name": "Enw dangos",
  "onboarding.profile.display_name_hint": "Eich enw llawn neu'ch enw hwyl…",
  "onboarding.profile.finish": "Gorffen",
  "onboarding.profile.note": "Bywgraffiad",
  "onboarding.profile.note_hint": "Gallwch @grybwyll pobl eraill neu #hashnodau…",
  "onboarding.profile.title": "Gosodiad proffil",
  "onboarding.profile.upload_avatar": "Llwytho llun proffil",
  "onboarding.profile.upload_header": "Llwytho pennyn proffil",
  "password_confirmation.exceeds_maxlength": "Mae'r cadarnhad cyfrinair yn fwy nag uchafswm hyd y cyfrinair",
  "password_confirmation.mismatching": "Nid yw'r cadarnhad cyfrinair yn cyfateb",
  "picture_in_picture.restore": "Rhowch ef yn ôl",
  "poll.closed": "Ar gau",
  "poll.refresh": "Adnewyddu",
  "poll.reveal": "Gweld y canlyniadau",
  "poll.total_people": "{count, plural, one {# person} other {# person}}",
  "poll.total_votes": "{count, plural, one {# bleidlais} other {# pleidlais}}",
  "poll.vote": "Pleidleisio",
  "poll.voted": "Fe wnaethoch chi bleidleisio dros yr ateb hwn",
  "poll.votes": "{votes, plural, one {# pleidlais} other {# pleidlais}}",
  "poll_button.add_poll": "Ychwanegu pleidlais",
  "poll_button.remove_poll": "Tynnu pleidlais",
  "privacy.change": "Addasu preifatrwdd y post",
  "privacy.direct.long": "Pawb sydd â sôn amdanyn nhw yn y postiad",
  "privacy.direct.short": "Crybwylliad preifat",
  "privacy.private.long": "Dim ond eich dilynwyr",
  "privacy.private.short": "Dilynwyr",
  "privacy.public.long": "Unrhyw un ar ac oddi ar Mastodon",
  "privacy.public.short": "Cyhoeddus",
  "privacy.quote.anyone": "{visibility}, dyfyniadau sy'n cael eu caniatáu",
  "privacy.quote.disabled": "{visibility}, dyfyniadau wedi'u hanalluogi",
  "privacy.quote.limited": "{visibility}, dyfyniadau wedi'u cyfyngu",
  "privacy.unlisted.additional": "Mae hwn yn ymddwyn yn union fel y cyhoeddus, ac eithrio na fydd y postiad yn ymddangos mewn ffrydiau byw neu hashnodau, archwilio, neu chwiliad Mastodon, hyd yn oed os ydych wedi eich cynnwys ar draws y cyfrif.",
  "privacy.unlisted.long": "Wedi'i guddio rhag canlyniadau chwilio Mastodon, trendio, a llinellau amser cyhoeddus",
  "privacy.unlisted.short": "Tewi'r cyhoeddus",
  "privacy_policy.last_updated": "Diweddarwyd ddiwethaf ar {date}",
  "privacy_policy.title": "Polisi Preifatrwydd",
  "quote_error.edit": "Does dim modd ychwanegu dyfyniadau wrth olygu postiad.",
  "quote_error.poll": "Dyw dyfynnu ddim yn cael ei ganiatáu gyda pholau.",
  "quote_error.private_mentions": "Does dim caniatâd i ddyfynnu gyda chrybwylliadau uniongyrchol.",
  "quote_error.quote": "Dim ond un dyfyniad ar y tro sy'n cael ei ganiatáu.",
  "quote_error.unauthorized": "Does gennych chi ddim awdurdod i ddyfynnu'r postiad hwn.",
  "quote_error.upload": "Dyw dyfynnu ddim yn cael ei ganiatáu gydag atodiadau cyfryngau.",
  "recommended": "Argymhellwyd",
  "refresh": "Adnewyddu",
  "regeneration_indicator.please_stand_by": "Arhoswch am dipyn.",
  "regeneration_indicator.preparing_your_home_feed": "Yn paratoi eich ffrwd gartref…",
  "relative_time.days": "{number}d",
  "relative_time.full.days": "{number, plural, one {# diwrnod} other {# diwrnod}} yn ôl",
  "relative_time.full.hours": "{number, plural, one {# awr} other {# awr}} yn ôl",
  "relative_time.full.just_now": "newydd ddigwydd",
  "relative_time.full.minutes": "{number, plural, one {# munud} other {# munud}} yn ôl",
  "relative_time.full.seconds": "{number, plural, one {# eiliad} other {# eiliad}} yn ôl",
  "relative_time.hours": "{number} awr",
  "relative_time.just_now": "nawr",
  "relative_time.minutes": "{number} munud",
  "relative_time.seconds": "{number} eiliad",
  "relative_time.today": "heddiw",
  "remove_quote_hint.button_label": "Iawn",
  "remove_quote_hint.message": "Gallwch wneud hynny o'r ddewislen dewisiadau {icon}.",
  "remove_quote_hint.title": "Eisiau dileu eich postiad sy'n cael ei ddyfynnu?",
  "reply_indicator.attachments": "{count, plural, one {# atodiad} other {# atodiad}}",
  "reply_indicator.cancel": "Diddymu",
  "reply_indicator.poll": "Pleidlais",
  "report.block": "Rhwystro",
  "report.block_explanation": "Ni welwch chi eu postiadau. Ni allan nhw weld eich postiadau na'ch dilyn. Byddan nhw'n gallu gweld eu bod nhw wedi'u rhwystro.",
  "report.categories.legal": "Cyfreithiol",
  "report.categories.other": "Arall",
  "report.categories.spam": "Sbam",
  "report.categories.violation": "Mae cynnwys yn torri un neu fwy o reolau'r gweinydd",
  "report.category.subtitle": "Dewiswch yr ateb gorau",
  "report.category.title": "Beth sy'n digwydd gyda'r {type} yma",
  "report.category.title_account": "proffil",
  "report.category.title_status": "post",
  "report.close": "Iawn",
  "report.collection_comment": "Pam ydych chi eisiau rhoi gwybod am y casgliad hwn?",
  "report.comment.title": "Oes unrhyw beth arall y dylem ei wybod yn eich barn chi?",
  "report.forward": "Ymlaen i {target}",
  "report.forward_hint": "Mae'r cyfrif o weinydd arall. Anfon copi anhysbys o'r adroddiad yno hefyd?",
  "report.mute": "Anwybyddu",
  "report.mute_explanation": "Ni fyddwch yn gweld eu postiadau. Gallant eich dilyn o hyd a gweld eich postiadau ac ni fyddant yn gwybod eu bod nhw wedi'u hanwybyddu.",
  "report.next": "Nesaf",
  "report.placeholder": "Sylwadau ychwanegol",
  "report.reasons.dislike": "Dydw i ddim yn ei hoffi",
  "report.reasons.dislike_description": "Dyw e ddim yn rhywbeth rydych am ei weld",
  "report.reasons.legal": "Mae'n anghyfreithlon",
  "report.reasons.legal_description": "Rydych chi'n credu ei fod yn torri cyfraith eich gwlad chi neu wlad y gweinydd",
  "report.reasons.other": "Mae'n rhywbeth arall",
  "report.reasons.other_description": "Dyw'r mater ddim yn ffitio i gategorïau eraill",
  "report.reasons.spam": "Sbam yw e",
  "report.reasons.spam_description": "Dolenni maleisus, ymgysylltu ffug, neu ymatebion ailadroddus",
  "report.reasons.violation": "Mae'n torri rheolau'r gweinydd",
  "report.reasons.violation_description": "Rydych yn ymwybodol ei fod yn torri rheolau penodol",
  "report.rules.subtitle": "Dewiswch bob un sy'n berthnasol",
  "report.rules.title": "Pa reolau sy'n cael eu torri?",
  "report.statuses.subtitle": "Dewiswch bob un sy'n berthnasol",
  "report.statuses.title": "Oes postiadau eraill sy'n cefnogi'r adroddiad hwn?",
  "report.submission_error": "Doedd dim modd cyflwyno'r adroddiad",
  "report.submission_error_details": "Gwiriwch eich cysylltiad rhwydwaith a cheisiwch eto yn nes ymlaen.",
  "report.submit": "Cyflwyno",
  "report.target": "Adrodd am {target}",
  "report.thanks.take_action": "Dyma'ch dewisiadau i reoli'r hyn a welwch ar Mastodon:",
  "report.thanks.take_action_actionable": "Tra byddwn yn adolygu hyn, gallwch gymryd camau yn erbyn @{name}:",
  "report.thanks.title": "Ddim eisiau gweld hwn?",
  "report.thanks.title_actionable": "Diolch am adrodd, byddwn yn ymchwilio i hyn.",
  "report.unfollow": "Dad-ddilyn @{name}",
  "report.unfollow_explanation": "Rydych chi'n dilyn y cyfrif hwn. I beidio â gweld eu postiadau yn eich ffrwd gartref mwyach, dad-ddilynwch nhw.",
  "report_notification.attached_statuses": "{count, plural, one {{count} postiad} other {{count} postiad}} wedi'i atodi",
  "report_notification.categories.legal": "Cyfreithiol",
  "report_notification.categories.legal_sentence": "cynnwys anghyfreithlon",
  "report_notification.categories.other": "Arall",
  "report_notification.categories.other_sentence": "arall",
  "report_notification.categories.spam": "Sbam",
  "report_notification.categories.spam_sentence": "sbam",
  "report_notification.categories.violation": "Torri rheol",
  "report_notification.categories.violation_sentence": "torri rheolau",
  "report_notification.open": "Agor adroddiad",
  "search.clear": "Clirio'r chwilio",
  "search.no_recent_searches": "Does dim chwiliadau diweddar",
  "search.placeholder": "Chwilio",
  "search.quick_action.account_search": "Proffiliau sy'n cyfateb i {x}",
  "search.quick_action.go_to_account": "Mynd i broffil {x}",
  "search.quick_action.go_to_hashtag": "Mynd i hashnod {x}",
  "search.quick_action.open_url": "Agor URL yn Mastodon",
  "search.quick_action.status_search": "Postiadau sy'n cyfateb i {x}",
  "search.search_or_paste": "Chwilio neu gludo URL",
  "search_popout.full_text_search_disabled_message": "Ddim ar gael ar {domain}.",
  "search_popout.full_text_search_logged_out_message": "Dim ond ar gael pan wedi mewngofnodi.",
  "search_popout.language_code": "Cod iaith ISO",
  "search_popout.options": "Dewisiadau chwilio",
  "search_popout.quick_actions": "Gweithredoedd cyflym",
  "search_popout.recent": "Chwilio diweddar",
  "search_popout.specific_date": "dyddiad penodol",
  "search_popout.user": "defnyddiwr",
  "search_results.accounts": "Proffilau",
  "search_results.all": "Popeth",
  "search_results.hashtags": "Hashnodau",
  "search_results.no_results": "Dim canlyniadau.",
  "search_results.no_search_yet": "Ceisiwch chwilio am bostiadau, proffiliau neu hashnodau.",
  "search_results.see_all": "Gweld y cyfan",
  "search_results.statuses": "Postiadau",
  "search_results.title": "Chwilio am {q}",
  "server_banner.about_active_users": "Pobl sy'n defnyddio'r gweinydd hwn yn ystod y 30 diwrnod diwethaf (Defnyddwyr Gweithredol Misol)",
  "server_banner.active_users": "defnyddwyr gweithredol",
  "server_banner.administered_by": "Gweinyddir gan:",
  "server_banner.is_one_of_many": "Mae {domain} yn un o'r nifer o weinyddion Mastodon annibynnol y gallwch eu defnyddio i gymryd rhan yn y ffedysawd.",
  "server_banner.more_about_this_server": "Mwy am y gweinydd hwn",
  "server_banner.server_stats": "Ystadegau'r gweinydd:",
  "sign_in_banner.create_account": "Creu cyfrif",
  "sign_in_banner.follow_anyone": "Dilynwch unrhyw un ar draws y ffedysawd a gweld y cyfan mewn trefn gronolegol. Dim algorithmau, hysbysebion, na straeon er mwyn cliciadau yn y golwg.",
  "sign_in_banner.mastodon_is": "Mastodon yw'r ffordd orau o gadw i fyny â'r hyn sy'n digwydd.",
  "sign_in_banner.sign_in": "Mewngofnodi",
  "sign_in_banner.sso_redirect": "Mewngofnodi neu Gofrestru",
  "skip_links.hotkey": "<span>Allwedd boeth</span> {hotkey}",
  "skip_links.skip_to_content": "Symud i'r prif gynnwys",
  "skip_links.skip_to_navigation": "Symud i'r prif lywio",
  "status.admin_account": "Agor rhyngwyneb cymedroli @{name}",
  "status.admin_domain": "Agor rhyngwyneb cymedroli {domain}",
  "status.admin_status": "Agor y postiad hwn yn y rhyngwyneb cymedroli",
  "status.all_disabled": "Mae hybu a dyfynnu wedi'u hanalluogi",
  "status.block": "Rhwystro @{name}",
  "status.bookmark": "Nod tudalen",
  "status.cancel_reblog_private": "Dadhybu",
  "status.cannot_quote": "Does dim caniatâd i chi ddyfynnu'r postiad hwn",
  "status.cannot_reblog": "Does dim modd hybu'r postiad hwn",
  "status.contains_quote": "Yn cynnwys dyfyniad",
  "status.context.loading": "Yn llwytho mwy o atebion",
  "status.context.loading_error": "Wedi methu llwytho atebion newydd",
  "status.context.loading_success": "Atebion newydd wedi'u llwytho",
  "status.context.more_replies_found": "Mwy o atebion wedi'u canfod",
  "status.context.retry": "Ceisio eto",
  "status.context.show": "Dangos",
  "status.continued_thread": "Edefyn parhaus",
  "status.copy": "Copïo dolen i'r post",
  "status.delete": "Dileu",
  "status.delete.success": "Postiad wedi'i ddileu",
  "status.detailed_status": "Golwg manwl o'r sgwrs",
  "status.direct": "Crybwyll yn breifat @{name}",
  "status.direct_indicator": "Crybwyll preifat",
  "status.edit": "Golygu",
  "status.edited": "Golygwyd ddiwethaf {date}",
  "status.edited_x_times": "Golygwyd {count, plural, one {{count} gwaith} other {{count} gwaith}}",
  "status.embed": "Cael y cod mewnblannu",
  "status.favourite": "Ffafrio",
  "status.favourites_count": "{count, plural, one {{counter} ffefryn} other {{counter} ffefryn}}",
  "status.filter": "Hidlo'r postiad hwn",
  "status.history.created": "Crëwyd gan {name} {date}",
  "status.history.edited": "Golygwyd gan {name} {date}",
  "status.load_more": "Llwythwch ragor",
  "status.media.open": "Cliciwch i agor",
  "status.media.show": "Cliciwch i ddangos",
  "status.media_hidden": "Cyfryngau wedi'u cuddio",
  "status.mention": "Crybwyll @{name}",
  "status.more": "Rhagor",
  "status.mute": "Anwybyddu @{name}",
  "status.mute_conversation": "Anwybyddu sgwrs",
  "status.open": "Ehangu'r post hwn",
  "status.pin": "Pinio ar y proffil",
  "status.quote": "Dyfynnu",
  "status.quote.cancel": "Diddymu'r dyfyniad",
  "status.quote_error.blocked_account_hint.title": "Mae'r postiad hwn wedi'i guddio oherwydd eich bod wedi rhwystro @{name}.",
  "status.quote_error.blocked_domain_hint.title": "Mae'r postiad hwn wedi'i guddio oherwydd eich bod wedi rhwystro {domain}.",
  "status.quote_error.filtered": "Wedi'i guddio oherwydd un o'ch hidlwyr",
  "status.quote_error.limited_account_hint.action": "Dangos beth bynnag",
  "status.quote_error.limited_account_hint.title": "Mae'r cyfrif hwn wedi'i guddio gan gymedrolwyr {domain}.",
  "status.quote_error.muted_account_hint.title": "Mae'r postiad hwn wedi'i guddio oherwydd eich bod wedi mudo @{name}.",
  "status.quote_error.not_available": "Postiad ddim ar gael",
  "status.quote_error.pending_approval": "Postiad yn yr arfaeth",
  "status.quote_error.pending_approval_popout.body": "Ar Mastodon, gallwch reoli os yw rhywun yn gallu eich dyfynnu. Mae'r postiad hwn yn cael ei ddal nôl tra'n bod yn cael cymeradwyaeth yr awdur gwreiddiol.",
  "status.quote_error.revoked": "Postiad wedi'i ddileu gan yr awdur",
  "status.quote_followers_only": "Dim ond dilynwyr all ddyfynnu'r postiad hwn",
  "status.quote_manual_review": "Bydd yr awdur yn ei adolygu ei hyn",
  "status.quote_noun": "Dyfynnu",
  "status.quote_policy_change": "Newid pwy all ddyfynnu",
  "status.quote_post_author": "Wedi dyfynnu postiad gan @{name}",
  "status.quote_private": "Does dim modd dyfynnu postiadau preifat",
  "status.quotes.empty": "Does neb wedi dyfynnu'r postiad hwn eto. Pan fydd rhywun yn gwneud hynny, bydd yn ymddangos yma.",
  "status.quotes.local_other_disclaimer": "Bydd dyfyniadau wedi'u gwrthod gan yr awdur ddim yn cael eu dangos.",
  "status.quotes.remote_other_disclaimer": "Dim ond dyfyniadau o {domain} sy'n siŵr o gael eu dangos yma. Bydd dyfyniadau wedi'u gwrthod gan yr awdur ddim yn cael eu dangos.",
  "status.quotes_count": "{count, plural, one {{counter} dyfyniad} other {{counter} dyfyniad}}",
  "status.read_more": "Darllen rhagor",
  "status.reblog": "Hybu",
  "status.reblog_or_quote": "Hybu neu ddyfynnu",
  "status.reblog_private": "Rhannwch eto gyda'ch dilynwyr",
  "status.reblogged_by": "Hybodd {name}",
  "status.reblogs.empty": "Does neb wedi hybio'r post yma eto. Pan y bydd rhywun yn gwneud, byddent yn ymddangos yma.",
  "status.reblogs_count": "{count, plural, one {{counter} hwb} other {{counter} hwb}}",
  "status.redraft": "Dileu ac ail lunio",
  "status.remove_bookmark": "Tynnu nod tudalen",
  "status.remove_favourite": "Tynnu o'r ffefrynnau",
  "status.remove_quote": "Tynnu",
  "status.replied_in_thread": "Wedi ateb mewn edefyn",
  "status.replied_to": "Wedi ymateb i {name}",
  "status.reply": "Ymateb",
  "status.replyAll": "Ateb edefyn",
  "status.report": "Adrodd ar @{name}",
  "status.request_quote": "Gofyn i gael dyfynnu",
  "status.revoke_quote": "Dileu fy mhostiad o bostiad @{name}",
  "status.sensitive_warning": "Cynnwys sensitif",
  "status.share": "Rhannu",
  "status.show_less_all": "Dangos llai i bawb",
  "status.show_more_all": "Dangos mwy i bawb",
  "status.show_original": "Dangos y gwreiddiol",
  "status.title.with_attachments": "Postiodd {user} {attachmentCount, plural, one {an attachment} other {{attachmentCount} attachments}}",
  "status.translate": "Cyfieithu",
  "status.translated_from_with": "Cyfieithwyd o {lang} gan ddefnyddio {provider}",
  "status.uncached_media_warning": "Dim rhagolwg ar gael",
  "status.unmute_conversation": "Dad-dewi sgwrs",
  "status.unpin": "Dadbinio o'r proffil",
  "subscribed_languages.lead": "Dim ond postiadau mewn ieithoedd penodol fydd yn ymddangos yn eich ffrydiau cartref a rhestr ar ôl y newid. Dewiswch ddim byd i dderbyn postiadau ym mhob iaith.",
  "subscribed_languages.save": "Cadw'r newidiadau",
  "subscribed_languages.target": "Newid ieithoedd tanysgrifio {target}",
  "tabs_bar.home": "Cartref",
  "tabs_bar.menu": "Dewislen",
  "tabs_bar.notifications": "Hysbysiadau",
  "tabs_bar.publish": "Postiad Newydd",
  "tabs_bar.search": "Chwilio",
  "tag.remove": "Tynnu",
  "terms_of_service.effective_as_of": "Yn effeithiol ers {date}",
  "terms_of_service.title": "Telerau Gwasanaeth",
  "terms_of_service.upcoming_changes_on": "Newidiadau i ddod ar {date}",
  "time_remaining.days": "{number, plural, one {# diwrnod} other {# diwrnod}} ar ôl",
  "time_remaining.hours": "{number, plural, one {# awr} other {# awr}} ar ôl",
  "time_remaining.minutes": "{number, plural, one {# munud} other {# munud}} ar ôl",
  "time_remaining.moments": "Munudau'n weddill",
  "time_remaining.seconds": "{number, plural, one {# eiliad} other {# eiliad}} ar ôl",
  "trends.counter_by_accounts": "{count, plural, zero {neb} one {{counter} person} two {{counter} berson} few {{counter} pherson} other {{counter} o bobl}} yn y {days, plural, one {diwrnod diwethaf} two {ddeuddydd diwethaf} other {{days} diwrnod diwethaf}}",
  "trends.trending_now": "Wrthi'n trendio",
  "ui.beforeunload": "Byddwch yn colli eich drafft os byddwch yn gadael Mastodon.",
  "units.short.billion": "{count}biliwn",
  "units.short.million": "{count}miliwn",
  "units.short.thousand": "{count}mil",
  "upload_area.title": "Llusgwch a gollwng i lwytho",
  "upload_button.label": "Ychwanegwch delweddau, fideo neu ffeil sain",
  "upload_error.limit": "Wedi mynd heibio'r uchafswm llwytho.",
  "upload_error.poll": "Does dim modd llwytho ffeiliau â phleidleisiau.",
  "upload_error.quote": "Does dim hawl llwytho i fyny gyda dyfyniadau.",
  "upload_form.drag_and_drop.instructions": "I godi atodiad cyfryngau, pwyswch y space neu enter. Wrth lusgo, defnyddiwch y bysellau saeth i symud yr atodiad cyfryngau i unrhyw gyfeiriad penodol. Pwyswch space neu enter eto i ollwng yr atodiad cyfryngau yn ei safle newydd, neu pwyswch escape i ddiddymu.",
  "upload_form.drag_and_drop.on_drag_cancel": "Cafodd llusgo ei ddiddymu. Cafodd atodi cyfryngau {item} ei ollwng.",
  "upload_form.drag_and_drop.on_drag_end": "Cafodd atodiad cyfryngau {item} ei ollwng.",
  "upload_form.drag_and_drop.on_drag_over": "Symudwyd atodiad cyfryngau {item}.",
  "upload_form.drag_and_drop.on_drag_start": "Wedi codi atodiad cyfryngau {item}.",
  "upload_form.edit": "Golygu",
  "upload_progress.label": "Yn llwytho...",
  "upload_progress.processing": "Wrthi'n prosesu…",
  "username.taken": "Mae'r enw defnyddiwr hwnnw'n cael ei ddefnyddio eisoes. Rhowch gynnig ar un arall",
  "video.close": "Cau fideo",
  "video.download": "Llwytho ffeil i lawr",
  "video.exit_fullscreen": "Gadael sgrin llawn",
  "video.expand": "Ymestyn fideo",
  "video.fullscreen": "Sgrin llawn",
  "video.hide": "Cuddio fideo",
  "video.mute": "Tewi",
  "video.pause": "Oedi",
  "video.play": "Chwarae",
  "video.skip_backward": "Symud nôl",
  "video.skip_forward": "Symud ymlaen",
  "video.unmute": "Dad-dewi",
  "video.volume_down": "Lefel sain i lawr",
  "video.volume_up": "Lefel sain i fyny",
  "visibility_modal.button_title": "Gosod gwelededd",
  "visibility_modal.direct_quote_warning.text": "Os byddwch chi'n cadw'r gosodiadau cyfredol, bydd y dyfyniad sydd wedi'i fewnosod yn cael ei drawsnewid yn ddolen.",
  "visibility_modal.direct_quote_warning.title": "Does dim modd mewnblannu dyfyniadau mewn crybwylliadau preifat",
  "visibility_modal.header": "Gwelededd a rhyngweithio",
  "visibility_modal.helper.direct_quoting": "Does dim modd dyfynnu crybwylliadau preifat ysgrifennwyd ar Mastodon.",
  "visibility_modal.helper.privacy_editing": "Does dim modd newid gwelededd ar ôl i bostiad gael ei gyhoeddi.",
  "visibility_modal.helper.privacy_private_self_quote": "Does dim modd cyhoeddi hunan-ddyfyniadau o bostiadau preifat.",
  "visibility_modal.helper.private_quoting": "Does dim modd dyfynnu crybwylliadau preifat ysgrifennwyd gan ddilynwyr.",
  "visibility_modal.helper.unlisted_quoting": "Pan fydd pobl yn eich dyfynnu, bydd eu postiad hefyd yn cael ei guddio rhag llinellau amser sy'n trendio.",
  "visibility_modal.instructions": "Rheolwch bwy all ryngweithio â'r postiad hwn. Gallwch hefyd osod gosodiadau i bob postiad yn y dyfodol drwy lywio i<link> Dewisiadau >Rhagosodiadau postio</link> .",
  "visibility_modal.privacy_label": "Gwelededd",
  "visibility_modal.quote_followers": "Dilynwyr yn unig",
  "visibility_modal.quote_label": "Pwy sy'n gallu dyfynnu",
  "visibility_modal.quote_nobody": "Dim ond fi",
  "visibility_modal.quote_public": "Pawb",
  "visibility_modal.save": "Cadw"
}
